'use client';
import { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import React from 'react';
import {
   Box,
   Flex,
   Table,
   Tbody,
   Td,
   Text,
   Tr,
   useColorModeValue,
   useDisclosure,
   Drawer,
   DrawerOverlay,
   DrawerContent,
   DrawerCloseButton,
   DrawerHeader,
   DrawerBody,
   useOutsideClick,
   Image,
   useColorMode,
} from '@chakra-ui/react';
import Select from 'react-select';
import 'jspdf-autotable';
import Card from 'components/card/Card';
import { GridItem, Input } from '@chakra-ui/react';
import nodata from 'assets/img/nfts/no data.svg';
import DotIcon from '../../../../assets/img/nfts/dot.svg';
import { Button, Thead, Th, Grid, IconButton, Tooltip } from '@chakra-ui/react';
import Download from '../../../../assets/img/nfts/download.svg';
import xls from '../../../../../src/assets/img/nfts/xls.svg';
import back from '../../../../../src/assets/img/nfts/back.svg';
import { Popover, PopoverTrigger, PopoverContent, PopoverBody } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import {
   clearCacheReport,
   deleteReportFormat,
   getReportFormat,
   getReportOutstanding,
} from '../../../../redux/actions/reports';
import {
   createColumnHelper,
   flexRender,
   getCoreRowModel,
   getSortedRowModel,
   useReactTable,
} from '@tanstack/react-table';
import { ChevronDownIcon, ChevronUpIcon, SearchIcon, ViewIcon } from '@chakra-ui/icons';
import ViewSingleCashBankData from 'components/UIcomponents/ViewSingleCashBankData';
import SalesSingleDataView from '../../sales/Pages/SalesInvoiceMaster/SaleSingleDataView';
import SalesDetails from 'components/salesDetails/SalesDetails';
import { deleteSaleInvoice, getSaleInvoice } from '../../../../redux/actions/salesInvoice';
import { deletePurchaseInvoice, getSinglePurchaseWithPrevAndNext } from '../../../../redux/actions/purchaseInvoice';
import { getReceiveInventory } from '../../../../redux/actions/receiveInventory';
import { getIssueInventory } from '../../../../redux/actions/issueInventory';
import { getAccountById, getAccount } from '../../../../redux/actions/account';
import { getDaybookForPayments } from '../../../../redux/actions/daybook';
import AccountingReportsFilter from '../components/AccountingReportsFilter';
import { deletePurchaseReturnInvoice, getSinglePurchaseReturn } from '../../../../redux/actions/purchaseReturnInvoice';
import {
   deleteSaleReturnInvoice,
   getSingleSalesReturnWithPrevAndNext,
} from '../../../../redux/actions/salesReturnInvoice';
import { deleteRecord } from 'utils/util';
import { getOneVoucher } from '../../../../redux/actions/voucher';
import { getShareCompanyOptions } from 'utils/util';
import { REPORT_TYPE } from 'constants';
import { osTypeOptions } from 'constants';
import { renderDynamicDropdown } from 'components/ui/DynamicDropdown';
import { jsPDF } from 'jspdf';
import { motion } from 'framer-motion';
import PeriodDatePicker from 'components/RangePicker/PeriodDatePicker';
import { MdCompress, MdDelete, MdExpand, MdOutlineRefresh } from 'react-icons/md';
import { useGlobal, useUser } from 'contexts';
import { IoFilterOutline } from 'react-icons/io5';
import ColumnShowHide from '../components/Columnshowhide';
import { FiPlusCircle } from 'react-icons/fi';
import { LucideEdit } from 'lucide-react';
import PaymentcaseFormEdit from '../../cash/PaymentcaseFormEdit';
import * as Yup from 'yup';
import { deleteRecordForSales } from 'utils/util';
import Loader from 'views/admin/default/Loader';
import DeletePasswordModal from 'views/admin/sales/Pages/SalesInvoiceMaster/DeletePasswordModal';
import { VariableSizeList } from 'react-window';

const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

const STATIC_COL_WIDTHS = {
   txndate: 110,
   docnumber: 80,
   daybookname: 160,
   dueDays: 80,
   txndays: 80,
   netAmount: 120,
   adjtxndate: 110,
   adjdaybookname: 160,
   returnadjamount: 120,
   otheradjamount: 120,
   balanceamount: 120,
};

const Outstanding = () => {
   const dispatch = useDispatch();
   const fromDateInputRef = useRef(null);
   const columnHelper = createColumnHelper();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
   const controlBg = useColorModeValue('#FFFFFF', '#2D3748');
   const controlBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const controlBorderHover = useColorModeValue('#CBD5E0', '#718096');
   const focusBoxShadow = useColorModeValue('0 0 0 1px #3182CE', '0 0 0 1px #63B3ED');
   const placeholderColor = useColorModeValue('#A0AEC0', '#718096');
   const optionBg = useColorModeValue('#FFFFFF', '#2D3748');
   const optionHoverBg = useColorModeValue('#EDF2F7', '#4A5568');
   const menuBg = useColorModeValue('#FFFFFF', '#2D3748');
   const menuBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const indicatorColor = useColorModeValue('#718096', '#A0AEC0');
   const indicatorHoverColor = useColorModeValue('#4A5568', '#CBD5E0');
   const reportformat = useSelector((state) => state.reports?.reportFormat || []);
   const [fromDate, setFromDate] = useState(null);
   const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);
   const [companyFilter, setCompanyFilter] = useState([]);
   const [searchQuery, setSearchQuery] = useState('');
   const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('');
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');
   const [reportType, setReportType] = useState(REPORT_TYPE.party);
   const [osType, setOsType] = useState(osTypeOptions[0].value);
   const [expandedItems, setExpandedItems] = useState({});
   const [sorting, setSorting] = useState([]);
   const [datePartyWiseSalesRange, setPartyWiseSalesDateRange] = useState('');
   const [dateRange, setDateRange] = useState(() => {
      const today = new Date();
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(today.getDate() - 6);
      return {
         fromDate: sevenDaysAgo.toISOString().split('T')[0],
         toDate: today.toISOString().split('T')[0],
      };
   });
   const [columnVisibility, setColumnVisibility] = useState({});
   const [isColumnSelectorOpen, setIsColumnSelectorOpen] = useState(false);
   const [isLoading, setIsLoading] = useState(false);
   const [isFilterLoading, setIsFilterLoading] = useState(false);
   const isFirstRenderFilter = useRef(true);
   const { companyList, company } = useGlobal();
   const dbName = company?.dbName;
   const [isEditShowHide, setIsEditShowHide] = useState(false);
   const [editData, setEditData] = useState({});
   const [isShowHideColumn, setIsShowHideColumn] = useState(false);
   const [showHideData, setShowHideData] = useState({});
   const { user } = useUser();
   const admin = user?.isAdmin;
   const rights = user?.userRights?.find((ur) => ur?.companyId === user?.loginhistory?.companyId);
   const [entityType, setEntityType] = useState([]);
   const [isEditFormOpen, setIsEditFormOpen] = React.useState(false);
   const [isBankPageTrue, setIsBankPageTrue] = React.useState(false);
   const [isOpenSingleViewinr, setIsOpenSingleViewinr] = React.useState(null);
   const [isOpenSingleViewcnb, setIsOpenSingleViewcnb] = React.useState(null);
   const [dynamicUserDetails, setDynamicUserDetails] = useState([]);
   const [isModalLoading, setIsModalLoading] = useState(false);
   const [isOpenPurchaseReturnSingleView, setIsOpenPurchaseReturnSingleView] = React.useState(null);
   const isStaticReportType = ['date', 'party', 'broker'].includes(reportType);
   const singleEntity = useSelector((state) => {
      if (entityType === 'receivemaster') return state?.receiveInventory?.single || {};
      else if (entityType === 'issuemaster') return state?.issueInventory?.single || {};
      else if (entityType === 'cash') return state.voucher?.single || {};
      else if (entityType === 'bank') return state.voucher?.single || {};
      else return {};
   });
   const validationSchema = Yup.object().shape({
      daybookId: Yup.number().required('Daybook is required'),
      accountId: Yup.number()
         .typeError('Account must be a valid')
         .required('Account is required')
         .min(1, 'Account must be greater than 0'),
      amount: Yup.number().required('Amount is required').min(0, 'Amount cannot be negative'),
      docNumber: Yup.string().required('Document number is required'),
      txnDate: Yup.date().required('Transaction date is required').typeError('Invalid transaction date'),
      txnType: Yup.number().required('Transaction type is required'),
   });
   const accountData = useSelector((state) => state.account.list);
   const singleVoucher = useSelector((state) => state.voucher?.single || null);
   const { userGlobalSettingsData } = useGlobal();
   const shouldSendIdInDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;
   const shouldSendIdInAccount = userGlobalSettingsData?.[0]?.askCompany?.account || false;
   const daybookTypeData = useSelector((state) => state.daybook?.listPayment || null);
   const [dataId, setDataId] = useState(null);
   const [isModalOpen, setIsModalOpen] = useState(false);
   const daybookData = useSelector((state) => state.daybook?.list || []);
   const [transactionType, setTransactionType] = useState('payment');
   const [receivedAmount, setReceivedAmount] = useState(0);
   const [totalPendingAccount, setTotalPendingAccount] = useState(0);
   const [updateFormLoading, setUpdateFormLoading] = useState(false);
   const [isOutstandingModalOpen, setIsOutstandingModalOpen] = useState(false);
   const [selectedEditAccount, setSelectedEditAccount] = useState(null);
   const [pendingVoucher, setPendingVoucher] = useState([]);
   const [errors, setErrors] = useState({});
   const [formData, setFormData] = useState({
      companyId: parseInt(localStorage.getItem('companyId')),
      daybookId: null,
      docNumber: 0,
      txnType: `${transactionType === 'payment' ? 1 : 0}`,
      txnDate: new Date().toISOString().split('T')[0],
      accountId: null,
      amount: receivedAmount ? receivedAmount : 0,
      brokerId: null,
      supplierId: null,
      chequeNo: 0,
      transactionNo: null,
      bankId: null,
      bankBranchId: null,
      particulars: '',
      depositeDate: null,
      clearingDate: null,
      tdsApplicable: false,
      tdsAccountId: null,
      tdsLimit: 0,
      tdsRate: 0,
      tdsCess: 0,
      tdsSurcharge: 0,
      tdsAmount: 0,
      tdsCessAmount: 0,
      tdsSurchargeAmount: 0,
      tdsHCessAmount: 0,
      tdsInterestAmount: 0,
      tdsPenaltyAmount: 0,
      tdsOthersAmount: 0,
      notes1: '',
      notes2: '',
      notes3: '',
      notes4: '',
      notes5: '',
      userNote: '',
      taxableValue: '',
      GSTAmount: 0,
      stateOfSupply: 0,
      isRCM: false,
      GSTSubTxnType: 0,
      HSNSACId: 0,
      typeofSupply: 0,
      partyBillNo: 0,
      GSTTxnType: 0,
      chequeDate: new Date().toISOString().split('T')[0],
      outAdjustments: [],
   });
   const companyId = Number(localStorage.getItem('companyId'));
   const userRights = user?.user?.userRights || user?.userRights;
   const cashReceiveRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.cashReceive
      : null;
   const cashPaymentRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.cashPayment
      : null;
   const bankReceiveRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.bankReceive
      : null;
   const bankPaymentRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.bankPayment
      : null;
   const saleInvoiceRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.saleinvoice
      : null;
   const saleReturnRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.salereturn
      : null;
   const purchaseInvoiceRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.purchaseinvoice
      : null;
   const purchaseReturnRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.purchasereturn
      : null;
   const account = useSelector((state) => state.account.single);
   const viewDatapr = useSelector((state) => state.purchaseReturnInvoice?.purchaseReturnData);
   const viewDatasr = useSelector((state) => state.salesReturnInvoice?.saleReturnData);
   const viewDatasi = useSelector((state) => state.sales?.single);
   const viewDatapi = useSelector((state) => state?.purchaseInvoice?.single);
   const { viewDetail, paginate } = useMemo(() => {
      const data =
         entityType === 'purchasereturn'
            ? viewDatapr?.data[0]
            : entityType === 'salereturn'
               ? viewDatasr?.data[0]
               : entityType === 'saleinvoice'
                  ? viewDatasi
                  : entityType === 'purchaseinvoice'
                     ? viewDatapi
                     : null;
      const pagination =
         entityType === 'purchasereturn'
            ? viewDatapr?.pagination
            : entityType === 'salereturn'
               ? viewDatasr?.pagination
               : entityType === 'saleinvoice'
                  ? viewDatasi?.pagination
                  : entityType === 'purchaseinvoice'
                     ? viewDatapi?.pagination
                     : null;
      return { viewDetail: data, paginate: pagination };
   }, [
      entityType,
      viewDatapr?.data,
      viewDatapr?.pagination,
      viewDatasr?.data,
      viewDatasr?.pagination,
      viewDatasi,
      viewDatapi,
   ]);

   const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure();
   const companyIds = useMemo(
      () =>
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
               ? [parseInt(localStorage.getItem('companyId'))]
               : [],
      [companyFilter],
   );

   const allowedDefNames = ['OutstandingDate', 'OutstandingParty', 'OutstandingBroker'];
   const dynamicOptions = reportformat
      .filter((item) => item.defName && allowedDefNames.includes(item.defName))
      .map((item) => ({
         id: item.id,
         value: item.defName && item.title,
         label: item.title,
         isDynamic: true,
         formatData: item,
      }));

   const staticReportTypeOptions = [
      { value: 'date', label: 'Date' },
      { value: 'party', label: 'Party' },
      { value: 'broker', label: 'Broker' },
   ];

   const reportTypeOptions = [
      ...staticReportTypeOptions,
      ...(dynamicOptions.length > 0 ? [{ label: 'Custom Formats', options: dynamicOptions }] : []),
   ];

   const columnsReportsSalesDetail = useCallback((dynamicOptionValues, isStaticReportType, textColor) => {
      const viewJson = dynamicOptionValues?.formatData?.viewJson || [];

      const convertBackendColor = (backendColor) => {
         if (!backendColor) return null;
         if (backendColor.startsWith('#')) return backendColor;
         if (backendColor.startsWith('0xff')) return '#' + backendColor.substring(4);
         if (/^[0-9A-Fa-f]{6}$/.test(backendColor)) return '#' + backendColor;
         return backendColor;
      };

      const getColumnInfo = (defName) => {
         const viewItem = viewJson.find(
            (item) =>
               item?.defName?.toLowerCase() === defName.toLowerCase() ||
               item?.title?.toLowerCase() === defName.toLowerCase(),
         );
         if (!viewItem || isStaticReportType) {
            return {
               title: defName,
               isShow: true,
               color: textColor,
               isBold: false,
               isItalic: false,
               orderNo: 0,
               flex: 1,
            };
         }
         return {
            title: viewItem.title || defName,
            isShow: viewItem.isShow === 'true' || viewItem.isShow === true,
            color: viewItem.color ? convertBackendColor(viewItem.color) : textColor,
            isBold: viewItem.isBold === 'true' || viewItem.isBold === true,
            isItalic: viewItem.isItalic === 'true' || viewItem.isItalic === true,
            orderNo: viewItem.orderNo ? parseInt(viewItem.orderNo) : 0,
            flex: viewItem.flex ? parseInt(viewItem.flex) : 1,
         };
      };

      const baseColumns = [
         { id: 'txndate', header: 'Date', accessor: 'txndate', ...getColumnInfo('date') },
         { id: 'docnumber', header: 'V.No.', accessor: 'docnumber', ...getColumnInfo('docnumber') },
         { id: 'daybookname', header: 'Daybook Name', accessor: 'daybookname', ...getColumnInfo('daybookname') },
         { id: 'dueDays', header: 'Due Days', accessor: 'dueDays', ...getColumnInfo('dueDays') },
         { id: 'txndays', header: 'Txn Days', accessor: 'txndays', ...getColumnInfo('txndays') },
         { id: 'netAmount', header: 'Net Amount', accessor: 'netAmount', ...getColumnInfo('netAmount') },
         { id: 'adjtxndate', header: 'Rec. Date', accessor: 'adjtxndate', ...getColumnInfo('adjtxndate') },
         { id: 'adjdaybookname', header: 'Rec. Book', accessor: 'adjdaybookname', ...getColumnInfo('adjdaybookname') },
         {
            id: 'returnadjamount',
            header: 'Ret. Adj. Amt.',
            accessor: 'returnadjamount',
            ...getColumnInfo('returnadjamount'),
         },
         { id: 'otheradjamount', header: 'Adj. Amt.', accessor: 'otheradjamount', ...getColumnInfo('otheradjamount') },
         { id: 'balanceamount', header: 'OS. Amt', accessor: 'balanceamount', ...getColumnInfo('balanceamount') },
      ];

      return baseColumns.filter((col) => col.isShow !== false).sort((a, b) => (a.orderNo || 0) - (b.orderNo || 0));
   });

   const dynamicValues = dynamicOptions.map((option) => option.value);
   const dynamicOptionValues = dynamicOptions.find((option) => option.value === reportType);
   const dynamicEditOption = dynamicOptionValues?.formatData.defName;
   const staticOption = staticReportTypeOptions.find((option) => option.value === reportType);

   const dynamicColumns = useMemo(() => {
      const format = reportformat.find((f) => f.id === reportType) || reportformat[0];
      return columnsReportsSalesDetail(reportType, format);
   }, [reportType, reportformat]);

   const columnsData = useMemo(() => {
      return dynamicColumns.map((col, index) => ({
         key: col?.id,
         label: col?.header,
         title: col?.header,
         width: col?.width,
         index: index + 1,
         status: true,
      }));
   }, [dynamicColumns]);

   // ─── Compute visible columns for the current view ─────────────────────────
   // Returns array of { id, header, width, align } used by BOTH header and body
   const visibleColDefs = useMemo(() => {
      if (dynamicOptionValues?.formatData?.viewJson) {
         const viewJson = dynamicOptionValues.formatData.viewJson;
         const totalFlex = viewJson.filter((i) => i.isShow).reduce((s, i) => s + (parseInt(i.flex) || 1), 0);
         return viewJson
            .filter((i) => i.isShow)
            .sort((a, b) => (parseInt(a.orderNo) || 0) - (parseInt(b.orderNo) || 0))
            .map((item) => ({
               id: item.defName,
               header: item.title || item.defName,
               // use percentage flex width so table stretches to 100%
               flexPct: `${(((parseInt(item.flex) || 1) / totalFlex) * 100).toFixed(2)}%`,
               align: ['os._amt', 'net_amount', 'ret._adj._amt.', 'adj._amt.', 'due_days'].includes(item.defName)
                  ? 'right'
                  : 'left',
               isBold: item.isBold === true || item.isBold === 'true',
               isItalic: item.isItalic === true || item.isItalic === 'true',
               color: item.color,
            }));
      }
      // Static columns
      const staticCols = columnsReportsSalesDetail(null, true, textColor || '#000000');
      const totalPx = staticCols.reduce((s, c) => s + (STATIC_COL_WIDTHS[c.id] || 100), 0);
      return staticCols.map((col) => ({
         id: col.id,
         header: col.header,
         flexPct: `${(((STATIC_COL_WIDTHS[col.id] || 100) / totalPx) * 100).toFixed(2)}%`,
         align: ['netAmount', 'dueDays', 'txndays', 'returnadjamount', 'otheradjamount', 'balanceamount'].includes(
            col.id,
         )
            ? 'right'
            : 'left',
         isBold: col.isBold || false,
         isItalic: col.isItalic || false,
         color: col.color || null,
      }));
   }, [dynamicOptionValues, columnsReportsSalesDetail, textColor]);

   const columns = useMemo(
      () =>
         dynamicColumns.map((column) =>
            columnHelper.accessor(column.id, {
               id: column.id,
               header: () => (
                  <Text
                     justifyContent="space-between"
                     align="center"
                     fontSize={{ sm: '10px', lg: '12px' }}
                     color={textColor}>
                     {column.header}
                  </Text>
               ),
               cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
            }),
         ),
      [columnHelper, dynamicColumns, textColor],
   );

   const companyOptions = useMemo(
      () => getShareCompanyOptions({ dbName, company: companyList }),
      [companyList, dbName],
   );
   const lastcompanyOptions = useMemo(() => {
      const currentUserCode = user?.loginhistory?.code;
      const currentCompanyId = user?.loginhistory?.companyId;

      // SHARED COMPANY MODE: When code is present
      if (currentUserCode) {
         // Find the company with matching ID AND matching dbName
         const sharedCompany = companyList.find(
            company => company.id === currentCompanyId && company.dbName === currentUserCode
         );

         if (sharedCompany) {
            return [{
               value: sharedCompany.id,
               label: sharedCompany.name,
               id: sharedCompany.id,
               name: sharedCompany.name,
            }];
         }

         // Fallback: try to find by dbName only
         const companiesWithDbName = companyList.filter(company => company.dbName === currentUserCode);
         if (companiesWithDbName.length > 0) {
            return companiesWithDbName.map(company => ({
               value: company.id,
               label: company.name,
               id: company.id,
               name: company.name,
            }));
         }

         return [];
      }

      // NORMAL MODE: When no code, show companies without dbName
      return companyList
         .filter(company => !company.dbName)
         .map(company => ({
            value: company.id,
            label: company.name,
            id: company.id,
            name: company.name,
         }));
   }, [companyList, user?.loginhistory?.code, user?.loginhistory?.companyId]);

   useEffect(() => {
      const storedCompanyId = localStorage.getItem('companyId');
      if (storedCompanyId && companyList.length > 0) {
         const companyId = parseInt(storedCompanyId);
         const matchingCompany = companyList.find((comp) => comp.id === companyId);
         if (matchingCompany) setCompanyFilter([matchingCompany.id]);
      }
   }, [companyList]);

   const fetchData = useCallback(async () => {
      setIsLoading(true);
      try {
         const storedCompanyId = parseInt(localStorage.getItem('companyId'), 10);
         const fallbackCompanyId = Number.isInteger(storedCompanyId) ? [storedCompanyId] : [];
         const companyIds = companyFilter.length > 0 ? companyFilter : fallbackCompanyId;
         if (!datePartyWiseSalesRange?.fromDate || !datePartyWiseSalesRange?.toDate || companyIds.length === 0) {
            console.warn('Missing required parameters for API call');
            return;
         }
         await dispatch(
            getReportOutstanding({
               companyIds: companyIds.join(','),
               isPurchaseOs: osType,
               fromDate: datePartyWiseSalesRange.fromDate,
               toDate: datePartyWiseSalesRange.toDate,
               search: debouncedSearchQuery,
            }),
         );
      } catch (error) {
         console.error('Error fetching outstanding details:', error);
      } finally {
         setIsLoading(false);
      }
   }, [dispatch, companyFilter, datePartyWiseSalesRange, osType, debouncedSearchQuery]);

   useEffect(() => {
      dispatch(clearCacheReport());
      const timer = setTimeout(fetchData, 300);
      return () => clearTimeout(timer);
   }, [fetchData, dispatch]);

   const handleDateRangeChange = useCallback((dates) => {
      if (!dates || dates.length !== 2) return;
      const [from, to] = dates.map((date) => (typeof date === 'string' ? date : date.toISOString().slice(0, 10)));
      setPartyWiseSalesDateRange({ fromDate: from, toDate: to });
   }, []);

   const debounce = (func, delay) => {
      let timer;
      return function (...args) {
         clearTimeout(timer);
         timer = setTimeout(() => func.apply(this, args), delay);
      };
   };

   const debouncedSearchHandler = useCallback(
      debounce((query) => setDebouncedSearchQuery(query), 500),
      [],
   );
   const handleSearchChange = useCallback(
      (e) => {
         const value = e.target.value;
         setSearchQuery(value);
         debouncedSearchHandler(value);
      },
      [debouncedSearchHandler],
   );

   const [expanded, setExpanded] = useState(false);
   const wrapperRef = useRef();
   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (searchQuery === '') setExpanded(false);
      },
   });

   const handleRefresh = useCallback(() => {
      setIsLoading(true);
      const companyIds =
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
               ? [parseInt(localStorage.getItem('companyId'))]
               : [];
      try {
         if (fromDate && toDate && companyIds.length > 0) {
            dispatch(
               getReportOutstanding({
                  companyIds: companyIds.toString(),
                  isPurchaseOs: osType,
                  fromDate,
                  toDate,
                  search: debouncedSearchQuery,
               }),
            );
         }
      } catch (error) {
         console.error('Refresh error:', error);
      } finally {
         setIsLoading(false);
      }
   }, [dispatch, companyFilter, fromDate, toDate, osType, debouncedSearchQuery]);

   const handleNextPage = () => { };
   const handlePrevPage = () => { };

   const salesReport = useSelector((state) => state.reports?.outstandingReport || []);
   const { isOpen, onOpen, onClose } = useDisclosure();

   useEffect(() => {
      if (isFirstRenderFilter.current) {
         isFirstRenderFilter.current = false;
         return;
      }
      setIsFilterLoading(false);
   }, [salesReport]);

   const table = useReactTable({
      data: salesReport,
      columns,
      state: { sorting, columnVisibility },
      onSortingChange: setSorting,
      onColumnVisibilityChange: setColumnVisibility,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
   });

   const toggleExpand = (id) => setExpandedItems((prev) => ({ ...prev, [id]: !prev[id] }));

   const expandAll = useCallback(() => {
      const newExpanded = {};
      salesReport.forEach((companyData) => {
         newExpanded[`company-${companyData.companyId}`] = true;
         companyData.data?.forEach((accountData) => {
            newExpanded[`account-${accountData.accountId}`] = true;
         });
      });
      setExpandedItems(newExpanded);
   }, [salesReport]);

   const collapseAll = useCallback(() => {
      const newExpanded = {};
      salesReport.forEach((companyData) => {
         newExpanded[`company-${companyData.companyId}`] = false;
         companyData.data?.forEach((accountData) => {
            newExpanded[`account-${accountData.accountId}`] = false;
         });
      });
      setExpandedItems(newExpanded);
   }, [salesReport]);

   const formatDataForExport = useCallback((salesReport) => {
      const flattenedData = [];
      salesReport.forEach((companyData) => {
         if (companyData.data && Array.isArray(companyData.data)) {
            companyData.data.forEach((accountData) => {
               if (accountData.data && Array.isArray(accountData.data)) {
                  accountData.data.forEach((transaction) => {
                     flattenedData.push({
                        Date: transaction.txndate ? new Date(transaction.txndate).toLocaleDateString('en-IN') : '',
                        'V.No.': transaction.docnumber || '',
                        'Due Days': transaction.dueDays != null ? transaction.dueDays : '',
                        'Net Amount': transaction.netAmount != null ? Number(transaction.netAmount) : '',
                        'Rec. Date': transaction.adjtxndate
                           ? new Date(transaction.adjtxndate).toLocaleDateString('en-IN')
                           : '',
                        'Rec. Book': transaction.adjdaybookname || '',
                        'Ret. Adj. Amt.':
                           transaction.returnadjamount != null ? Number(transaction.returnadjamount) : '',
                        'Adj. Amt.': transaction.otheradjamount != null ? Number(transaction.otheradjamount) : '',
                        'OS. Amt': transaction.balanceamount != null ? Number(transaction.balanceamount) : '',
                     });
                  });
               }
            });
         }
      });
      return flattenedData;
   }, []);

   const downloadAsExcel = useCallback(() => {
      const data = formatDataForExport(salesReport);
      if (data.length === 0) {
         alert('No data available to download.');
         return;
      }

      // Import the library
      const XLSX = require('xlsx-js-style');

      // Create workbook
      const wb = XLSX.utils.book_new();

      // Determine if this is a dynamic format
      let isDynamicFormat = false;
      let formatData = null;
      let visibleColumns = [];

      // Check if reportType exists in dynamicOptions
      if (dynamicOptions && Array.isArray(dynamicOptions)) {
         const selectedFormat = dynamicOptions.find((opt) => opt.value === reportType);
         if (selectedFormat && selectedFormat.formatData) {
            isDynamicFormat = true;
            formatData = selectedFormat.formatData;
         }
      }

      if (isDynamicFormat && formatData?.viewJson) {
         // Dynamic format logic
         visibleColumns = formatData.viewJson
            .filter((item) => item.isShow === true || item.isShow === 'true')
            .sort((a, b) => (parseInt(a.orderNo) || 0) - (parseInt(b.orderNo) || 0));
      } else {
         // Static format logic
         const staticColumns = columnsReportsSalesDetail(null, true, textColor || '#000000');
         visibleColumns = staticColumns.filter((col) => {
            return columnVisibility && columnVisibility[col.id] !== false;
         });
      }

      if (!visibleColumns || visibleColumns.length === 0) {
         alert('No columns available for Excel generation. Please check your column settings.');
         return;
      }

      // Helper function to convert backend color format to hex for Excel
      const convertBackendColorToHex = (backendColor) => {
         if (!backendColor) return '000000';
         if (backendColor.startsWith('#')) {
            return backendColor.substring(1);
         }
         if (backendColor.startsWith('0xff')) {
            return backendColor.substring(4);
         }
         if (/^[0-9A-Fa-f]{6}$/.test(backendColor)) {
            return backendColor;
         }
         return '000000';
      };

      // Helper function to get column styling for dynamic format
      const getColumnStyles = (columnDefName) => {
         if (!isDynamicFormat || !formatData?.viewJson) {
            return {
               font: { color: { rgb: '000000' } },
               alignment: { horizontal: 'left' },
            };
         }

         const viewItem = formatData.viewJson.find((item) => item.defName === columnDefName);

         const styles = {
            font: {
               color: { rgb: viewItem?.color ? convertBackendColorToHex(viewItem.color) : '000000' },
            },
            alignment: { horizontal: 'left' },
         };

         if (viewItem?.isBold === true || viewItem?.isBold === 'true') {
            styles.font.bold = true;
         }

         if (viewItem?.isItalic === true || viewItem?.isItalic === 'true') {
            styles.font.italic = true;
         }

         return styles;
      };

      // Define base styles
      const headerStyle = {
         font: { bold: true, color: { rgb: '000000' } },
         fill: { fgColor: { rgb: 'F5F5F5' } },
         alignment: { horizontal: 'center' },
         border: {
            top: { style: 'thin', color: { rgb: '000000' } },
            bottom: { style: 'thin', color: { rgb: '000000' } },
            left: { style: 'thin', color: { rgb: '000000' } },
            right: { style: 'thin', color: { rgb: '000000' } },
         },
      };

      const companyStyle = {
         font: { bold: true, color: { rgb: '7D1214' } },
         fill: { fgColor: { rgb: 'E6E6E6' } },
         alignment: { horizontal: 'left' },
      };

      const partyStyle = {
         font: { bold: true, color: { rgb: '2A3335' } },
         fill: { fgColor: { rgb: 'F6F0F0' } },
         alignment: { horizontal: 'left' },
      };

      const oddRowStyle = { fill: { fgColor: { rgb: 'E6F2FF' } } };
      const evenRowStyle = { fill: { fgColor: { rgb: 'FFFFFF' } } };

      const numericStyle = {
         alignment: { horizontal: 'right' },
         numFmt: '#,##0.00',
      };

      const dateStyle = {
         alignment: { horizontal: 'left' },
         numFmt: 'dd/mm/yyyy', // Add date format
      };

      const dueDaysStyle = {
         alignment: { horizontal: 'right' },
         numFmt: '0', // Integer format for due days
      };

      const totalStyle = {
         font: { bold: true, color: { rgb: '7D1214' } },
         fill: { fgColor: { rgb: 'E6E6E6' } },
         alignment: { horizontal: 'right' },
      };

      // Helper function to get cell value based on column configuration
      const getCellValue = (transaction, column) => {
         if (isDynamicFormat) {
            // Dynamic format - use field mapping
            const fieldMapping = {
               date: 'txndate',
               'v.no.': 'docnumber',
               due_days: 'dueDays',
               net_amount: 'netAmount',
               'rec._date': 'adjtxndate',
               'rec._book': 'adjdaybookname',
               'ret._adj._amt.': 'returnadjamount',
               'adj._amt.': 'otheradjamount',
               'os._amt': 'balanceamount',
            };

            const fieldId = fieldMapping[column.defName] || column.defName;
            return getCellValueByFieldId(transaction, fieldId);
         } else {
            // Static format - use column id directly
            return getCellValueByFieldId(transaction, column.id);
         }
      };

      // Helper function to get cell value by field ID - MODIFIED
      const getCellValueByFieldId = (transaction, fieldId) => {
         switch (fieldId) {
            case 'txndate':
               return transaction.txndate ? new Date(transaction.txndate) : '';
            case 'docnumber':
               return transaction.docnumber || '';
            case 'dueDays':
               // MODIFIED: Show 0 if dueDays is 0 or "0", otherwise show the value or empty
               if (transaction.dueDays === 0 || transaction.dueDays === '0') {
                  return 0;
               }
               return transaction.dueDays != null ? Number(transaction.dueDays) : '';
            case 'txndays':
               // MODIFIED: Show 0 if dueDays is 0 or "0", otherwise show the value or empty
               if (transaction.txndays === 0 || transaction.txndays === '0') {
                  return 0;
               }
               return transaction.txndays != null ? Number(transaction.txndays) : '';
            case 'netAmount':
               return transaction.netAmount != null ? Number(transaction.netAmount) : '';
            case 'adjtxndate':
               // MODIFIED: Return "-" if adjtxndate is empty/null, otherwise Date object
               if (!transaction.adjtxndate) {
                  return '-';
               }
               return new Date(transaction.adjtxndate);
            case 'adjdaybookname':
               return transaction.adjdaybookname || '-'; // Also add "-" for empty rec. book
            case 'returnadjamount':
               return transaction.returnadjamount != null ? Number(transaction.returnadjamount) : '';
            case 'otheradjamount':
               return transaction.otheradjamount != null ? Number(transaction.otheradjamount) : '';
            case 'balanceamount':
               return transaction.balanceamount != null ? Number(transaction.balanceamount) : '';
            default:
               return transaction[fieldId] || '';
         }
      };

      // Helper function to determine if a field is numeric
      const isNumericField = (column) => {
         const numericFields = ['netAmount', 'returnadjamount', 'otheradjamount', 'balanceamount', 'dueDays'];

         if (isDynamicFormat) {
            const fieldMapping = {
               due_days: 'dueDays',
               net_amount: 'netAmount',
               'ret._adj._amt.': 'returnadjamount',
               'adj._amt.': 'otheradjamount',
               'os._amt': 'balanceamount',
            };
            const fieldId = fieldMapping[column.defName] || column.defName;
            return numericFields.includes(fieldId);
         } else {
            return numericFields.includes(column.id);
         }
      };

      // Helper function to determine if a field is a date
      // Helper function to determine if a field is a date
      const isDateField = (column) => {
         const dateFields = ['txndate', 'adjtxndate'];

         if (isDynamicFormat) {
            const fieldMapping = {
               date: 'txndate',
               'rec._date': 'adjtxndate',
            };
            const fieldId = fieldMapping[column.defName] || column.defName;
            return dateFields.includes(fieldId);
         } else {
            return dateFields.includes(column.id);
         }
      };

      // NEW helper function to check if a field is Rec. Date specifically
      const isRecDateField = (column) => {
         if (isDynamicFormat) {
            return column.defName === 'rec._date';
         } else {
            return column.id === 'adjtxndate';
         }
      };

      // Helper function to determine if a field is due days
      const isDueDaysField = (column) => {
         if (isDynamicFormat) {
            return column.defName === 'due_days';
         } else {
            return column.id === 'dueDays';
         }
      };

      // Helper function to get column header
      const getColumnHeader = (column) => {
         if (isDynamicFormat) {
            return column.title || column.defName;
         } else {
            return column.header;
         }
      };

      // Prepare the worksheet data
      const wsData = [];

      // Add header row
      const headerRow = visibleColumns.map((column) => ({
         v: getColumnHeader(column),
         t: 's',
         s: headerStyle,
      }));
      wsData.push(headerRow);

      // Track current row for styling and merges
      let currentRow = 1; // Header is row 0
      const merges = [];

      salesReport.forEach((companyData) => {
         // Add company row (fill all columns with styled cells)
         const companyRow = visibleColumns.map((column, index) => ({
            v: index === 0 ? companyData.companyName : '',
            t: 's',
            s: companyStyle,
         }));
         wsData.push(companyRow);

         // Add merge for company row (span all columns)
         if (visibleColumns.length > 1) {
            merges.push({
               s: { r: currentRow, c: 0 },
               e: { r: currentRow, c: visibleColumns.length - 1 },
            });
         }
         currentRow++;

         if (companyData.data && Array.isArray(companyData.data)) {
            companyData.data.forEach((accountData) => {
               // Add party row (fill all columns with styled cells)
               const partyRow = visibleColumns.map((column, index) => ({
                  v: index === 0 ? `Party: ${accountData.accountName}` : '',
                  t: 's',
                  s: partyStyle,
               }));
               wsData.push(partyRow);

               // Add merge for party row (span all columns)
               if (visibleColumns.length > 1) {
                  merges.push({
                     s: { r: currentRow, c: 0 },
                     e: { r: currentRow, c: visibleColumns.length - 1 },
                  });
               }
               currentRow++;

               if (accountData.data && Array.isArray(accountData.data)) {
                  // Show all transactions without filtering
                  const allTransactions = accountData.data;

                  // Add all transactions
                  allTransactions.forEach((transaction, idx) => {
                     const rowStyle = idx % 2 === 0 ? evenRowStyle : oddRowStyle;

                     const transactionRow = visibleColumns.map((column) => {
                        const value = getCellValue(transaction, column);
                        const isNumeric = isNumericField(column);
                        const isDate = isDateField(column);
                        const isRecDate = isRecDateField(column); // NEW
                        const isDueDays = isDueDaysField(column);
                        const columnStyles = isDynamicFormat ? getColumnStyles(column.defName) : {};

                        let cellStyle = { ...rowStyle, ...columnStyles };

                        if (isDate && value instanceof Date && !isNaN(value)) {
                           // Date field - apply date style
                           cellStyle = { ...cellStyle, ...dateStyle };
                           return {
                              v: value,
                              t: 'd',
                              s: cellStyle,
                           };
                        } else if (isRecDate && value === '-') {
                           // Special handling for Rec. Date when it's "-"
                           return {
                              v: '-',
                              t: 's',
                              s: cellStyle,
                           };
                        } else if (isDueDays && (value === 0 || value === '0')) {
                           // Due days field with value 0
                           cellStyle = { ...cellStyle, ...dueDaysStyle };
                           return {
                              v: 0,
                              t: 'n',
                              s: cellStyle,
                           };
                        } else if (isNumeric && value !== '' && value !== null && value !== undefined) {
                           // Numeric field
                           cellStyle = { ...cellStyle, ...numericStyle };
                           return {
                              v: value,
                              t: 'n',
                              s: cellStyle,
                           };
                        } else {
                           // Text field
                           return {
                              v: value,
                              t: 's',
                              s: cellStyle,
                           };
                        }
                     });

                     wsData.push(transactionRow);
                     currentRow++;
                  });

                  // Calculate and add party total
                  const uniqueTransactions = allTransactions.filter(
                     (item, index, arr) => index === 0 || item.id !== arr[index - 1].id,
                  );

                  // Calculate totals for all numeric columns
                  const totals = {};
                  visibleColumns.forEach((column) => {
                     if (isNumericField(column)) {
                        const fieldId = isDynamicFormat
                           ? {
                              due_days: 'dueDays',
                              net_amount: 'netAmount',
                              'ret._adj._amt.': 'returnadjamount',
                              'adj._amt.': 'otheradjamount',
                              'os._amt': 'balanceamount',
                           }[column.defName] || column.defName
                           : column.id;

                        if (fieldId === 'netAmount' || fieldId === 'balanceamount') {
                           totals[fieldId] = uniqueTransactions.reduce(
                              (sum, item) => sum + (Number(item[fieldId]) || 0),
                              0,
                           );
                        } else {
                           totals[fieldId] = allTransactions.reduce(
                              (sum, item) => sum + (Number(item[fieldId]) || 0),
                              0,
                           );
                        }
                     }
                  });

                  // Add total row
                  const totalRow = visibleColumns.map((column, index) => {
                     if (index === 0) {
                        return {
                           v: 'Total:',
                           t: 's',
                           s: { ...totalStyle, alignment: { horizontal: 'left' } },
                        };
                     } else if (isNumericField(column)) {
                        const fieldId = isDynamicFormat
                           ? {
                              due_days: 'dueDays',
                              net_amount: 'netAmount',
                              'ret._adj._amt.': 'returnadjamount',
                              'adj._amt.': 'otheradjamount',
                              'os._amt': 'balanceamount',
                           }[column.defName] || column.defName
                           : column.id;

                        const totalValue = totals[fieldId];
                        if (totalValue !== undefined) {
                           return {
                              v: totalValue,
                              t: 'n',
                              s: { ...totalStyle, ...numericStyle },
                           };
                        }
                     }

                     return {
                        v: '',
                        t: 's',
                        s: totalStyle,
                     };
                  });

                  wsData.push(totalRow);
                  currentRow++;
               }
            });
         }
      });

      // Create worksheet with data
      const ws = XLSX.utils.aoa_to_sheet(wsData);

      // Add merges to worksheet
      ws['!merges'] = merges;

      // Calculate dynamic column widths
      let columnWidths = [];

      if (isDynamicFormat && formatData?.viewJson) {
         // For dynamic format, use flex values to determine relative widths
         const totalFlex = visibleColumns.reduce((sum, col) => sum + (parseInt(col.flex) || 1), 0);
         const baseWidth = 200; // Base total width to distribute

         visibleColumns.forEach((column) => {
            const flexRatio = (parseInt(column.flex) || 1) / totalFlex;
            const width = Math.max(10, Math.floor(baseWidth * flexRatio) / 5); // Convert to approximate character width
            columnWidths.push({ wch: width });
         });
      } else {
         // For static format, use predefined widths
         visibleColumns.forEach((column) => {
            let width;
            switch (column.id) {
               case 'txndate':
               case 'adjtxndate': // Added for rec date
                  width = 12;
                  break;
               case 'docnumber':
                  width = 10;
                  break;
               case 'dueDays':
                  width = 10;
                  break;
               case 'netAmount':
               case 'returnadjamount':
               case 'otheradjamount':
               case 'balanceamount':
                  width = 15;
                  break;
               case 'adjdaybookname':
                  width = 20;
                  break;
               default:
                  width = 15;
            }
            columnWidths.push({ wch: width });
         });
      }

      // Calculate maximum company and party name lengths for dynamic adjustment of first column
      let maxCompanyNameLength = 0;
      let maxPartyNameLength = 0;

      salesReport.forEach((companyData) => {
         if (companyData.companyName) {
            maxCompanyNameLength = Math.max(maxCompanyNameLength, companyData.companyName.length);
         }
         if (companyData.data && Array.isArray(companyData.data)) {
            companyData.data.forEach((accountData) => {
               if (accountData.accountName) {
                  maxPartyNameLength = Math.max(maxPartyNameLength, `Party: ${accountData.accountName}`.length);
               }
            });
         }
      });

      // Ensure first column is wide enough for company/party names
      const firstColumnMinWidth = Math.max(20, maxCompanyNameLength + 5, maxPartyNameLength + 5) / 5;
      if (columnWidths[0] && columnWidths[0].wch < firstColumnMinWidth) {
         columnWidths[0].wch = firstColumnMinWidth;
      }

      // Set column widths
      ws['!cols'] = columnWidths;

      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(wb, ws, 'Outstanding Report');

      // Generate Excel file
      XLSX.writeFile(wb, 'outstanding_report.xlsx');
   }, [
      formatDataForExport,
      salesReport,
      dynamicOptions,
      reportType,
      columnsReportsSalesDetail,
      textColor,
      columnVisibility,
   ]);

   const handleDownloadPDF = useCallback(() => {
      const doc = new jsPDF('landscape');
      const pageWidth = doc.internal.pageSize.getWidth();
      const margin = 10; // Reduced margin
      let currentY = 10; // Start closer to top

      // Set default font with smaller size
      doc.setFont('helvetica');
      doc.setFontSize(8); // Set default font size to 8

      // Title
      doc.setFontSize(10); // Slightly larger for title but still small
      doc.setTextColor(0, 0, 0);

      // Center title
      const title = 'Outstanding Report';
      const titleWidth = (doc.getStringUnitWidth(title) * doc.internal.getFontSize()) / doc.internal.scaleFactor;
      const titleX = (pageWidth - titleWidth) / 2;
      doc.text(title, titleX, currentY);
      currentY += 4; // Reduced spacing

      // Date range
      doc.setFontSize(8);
      const dateText = `Date Range: ${datePartyWiseSalesRange?.fromDate || ''} to ${datePartyWiseSalesRange?.toDate || ''
         }`;
      const dateWidth = (doc.getStringUnitWidth(dateText) * doc.internal.getFontSize()) / doc.internal.scaleFactor;
      const dateX = (pageWidth - dateWidth) / 2;
      doc.text(dateText, dateX, currentY);
      currentY += 3; // Reduced spacing

      // Company filter
      const selectedCompanies = companyFilter
         .map((id) => companyList.find((c) => c.id === id)?.name)
         .filter(Boolean)
         .join(', ');

      if (selectedCompanies) {
         const companyText = `Company: ${selectedCompanies}`;
         const companyWidth =
            (doc.getStringUnitWidth(companyText) * doc.internal.getFontSize()) / doc.internal.scaleFactor;
         const companyX = (pageWidth - companyWidth) / 2;
         doc.text(companyText, companyX, currentY);
         currentY += 4; // Reduced spacing
      }

      // Determine if this is a dynamic format
      let isDynamicFormat = false;
      let formatData = null;
      let visibleColumns = [];

      // Check if reportType exists in dynamicOptions
      if (dynamicOptions && Array.isArray(dynamicOptions)) {
         const selectedFormat = dynamicOptions.find((opt) => opt.value === reportType);
         if (selectedFormat && selectedFormat.formatData) {
            isDynamicFormat = true;
            formatData = selectedFormat.formatData;
         }
      }

      if (isDynamicFormat && formatData?.viewJson) {
         // Dynamic format logic
         visibleColumns = formatData.viewJson.filter((item) => item.isShow === true || item.isShow === 'true');
      } else {
         // Static format logic
         const staticColumns = columnsReportsSalesDetail(null, true, textColor || '#000000');
         visibleColumns = staticColumns.filter((col) => {
            return columnVisibility && columnVisibility[col.id] !== false;
         });
      }

      if (!visibleColumns || visibleColumns.length === 0) {
         alert('No columns available for PDF generation. Please check your column settings.');
         return;
      }

      // Helper function to convert backend color format to hex
      const convertBackendColor = (backendColor) => {
         if (!backendColor) return [0, 0, 0];
         if (backendColor.startsWith('#')) {
            const hex = backendColor.substring(1);
            return [
               parseInt(hex.substring(0, 2), 16),
               parseInt(hex.substring(2, 4), 16),
               parseInt(hex.substring(4, 6), 16),
            ];
         }
         if (backendColor.startsWith('0xff')) {
            const hex = backendColor.substring(4);
            return [
               parseInt(hex.substring(0, 2), 16),
               parseInt(hex.substring(2, 4), 16),
               parseInt(hex.substring(4, 6), 16),
            ];
         }
         if (/^[0-9A-Fa-f]{6}$/.test(backendColor)) {
            return [
               parseInt(backendColor.substring(0, 2), 16),
               parseInt(backendColor.substring(2, 4), 16),
               parseInt(backendColor.substring(4, 6), 16),
            ];
         }
         return [0, 0, 0];
      };

      // Helper function to get column styling for dynamic format
      const getColumnStyles = (columnDefName) => {
         if (!isDynamicFormat || !formatData?.viewJson) {
            return {
               color: [0, 0, 0],
               fontStyle: 'normal',
               isBold: false,
               isItalic: false,
            };
         }

         const viewItem = formatData.viewJson.find((item) => item.defName === columnDefName);

         return {
            color: viewItem?.color ? convertBackendColor(viewItem.color) : [0, 0, 0],
            fontStyle: viewItem?.isBold ? 'bold' : 'normal',
            isBold: viewItem?.isBold === true || viewItem?.isBold === 'true',
            isItalic: viewItem?.isItalic === true || viewItem?.isItalic === 'true',
         };
      };

      // Define styles
      const styles = {
         header: {
            fillColor: [245, 245, 245],
            textColor: [0, 0, 0],
            fontStyle: 'bold',
         },
         companyHeader: {
            fillColor: [230, 230, 230],
            textColor: [125, 18, 20],
            fontStyle: 'bold',
         },
         partyHeader: {
            fillColor: [246, 240, 240],
            textColor: [42, 51, 53],
            fontStyle: 'bold',
         },
         oddRow: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
         },
         evenRow: {
            fillColor: [230, 242, 255],
            textColor: [0, 0, 0],
         },
         total: {
            fillColor: [230, 230, 230],
            textColor: [125, 18, 20],
            fontStyle: 'bold',
         },
      };

      // Function to format numbers - ensure string return
      const formatNumber = (num) => {
         if (num === null || num === undefined) return '-';
         return String(
            Number(num).toLocaleString('en-IN', {
               minimumFractionDigits: 2,
               maximumFractionDigits: 2,
            }),
         );
      };

      // Function to format dates - ensure string return
      const formatDate = (dateStr) => {
         if (!dateStr) return '-';
         try {
            const date = new Date(dateStr);
            return String(date.toLocaleDateString('en-IN'));
         } catch (error) {
            return '-';
         }
      };

      // Track if we've drawn headers on the current page
      let headersDrawnOnPage = false;

      // Function to add a new page if needed
      const checkPageBreak = (heightNeeded = 10) => {
         if (currentY + heightNeeded > doc.internal.pageSize.getHeight() - 10) {
            doc.addPage('landscape');
            currentY = 10;
            headersDrawnOnPage = false; // Reset flag for new page
         }
      };

      // Calculate column positions and widths
      const calculateColumnLayout = () => {
         const columns = [];
         let xPos = margin;
         const availableWidth = pageWidth - margin * 2;

         if (isDynamicFormat && formatData?.viewJson) {
            // Dynamic format logic
            const sortedColumns = formatData.viewJson
               .filter((item) => item.isShow === true || item.isShow === 'true')
               .sort((a, b) => (parseInt(a.orderNo) || 0) - (parseInt(b.orderNo) || 0));

            const totalFlex = sortedColumns.reduce((sum, col) => sum + (parseInt(col.flex) || 1), 0);

            sortedColumns.forEach((viewItem) => {
               const flexRatio = (parseInt(viewItem.flex) || 1) / totalFlex;
               const width = Math.floor(availableWidth * flexRatio);

               const fieldMapping = {
                  date: 'txndate',
                  'v.no.': 'docnumber',
                  'daybook.name': 'daybookname',
                  due_days: 'dueDays',
                  net_amount: 'netAmount',
                  'rec._date': 'adjtxndate',
                  'rec._book': 'adjdaybookname',
                  'ret._adj._amt.': 'returnadjamount',
                  'adj._amt.': 'otheradjamount',
                  'os._amt': 'balanceamount',
               };

               const fieldId = fieldMapping[viewItem.defName] || viewItem.defName;

               columns.push({
                  id: fieldId,
                  defName: viewItem.defName,
                  header: viewItem.title || viewItem.defName,
                  x: xPos,
                  width: width,
                  align: ['netAmount', 'returnadjamount', 'otheradjamount', 'balanceamount', 'dueDays'].includes(
                     fieldId,
                  )
                     ? 'right'
                     : 'left',
                  styles: getColumnStyles(viewItem.defName),
               });

               xPos += width;
            });
         } else {
            // Static format logic
            visibleColumns.forEach((column) => {
               let width;
               switch (column.id) {
                  case 'txndate':
                     width = 22;
                     break;
                  case 'docnumber':
                     width = 18;
                     break;
                  case 'daybookname':
                     width = 35;
                     break;
                  case 'dueDays':
                     width = 14;
                     break;
                  case 'txndays':
                     width = 14;
                     break;
                  case 'netAmount':
                     width = 25;
                     break;
                  case 'adjtxndate':
                     width = 22;
                     break;
                  case 'adjdaybookname':
                     width = 35;
                     break;
                  case 'returnadjamount':
                     width = 25;
                     break;
                  case 'otheradjamount':
                     width = 25;
                     break;
                  case 'balanceamount':
                     width = 25;
                     break;
                  default:
                     width = 20;
               }

               columns.push({
                  id: column.id,
                  header: column.header,
                  x: xPos,
                  width: width,
                  align: [
                     'netAmount',
                     'returnadjamount',
                     'otheradjamount',
                     'balanceamount',
                     'dueDays',
                     'txndays',
                  ].includes(column.id)
                     ? 'right'
                     : 'left',
                  styles: { color: [0, 0, 0], fontStyle: 'normal', isBold: false, isItalic: false },
               });

               xPos += width;
            });

            // Scale if needed for static format
            const totalWidth = columns.reduce((sum, col) => sum + col.width, 0);
            if (totalWidth > availableWidth) {
               const scaleFactor = availableWidth / totalWidth;
               let adjustedX = margin;

               columns.forEach((column) => {
                  column.width = Math.floor(column.width * scaleFactor);
                  column.x = adjustedX;
                  adjustedX += column.width;
               });
            }
         }

         return columns;
      };

      // Helper function to get cell value based on column ID
      const getCellValue = (transaction, columnId) => {
         let value;

         switch (columnId) {
            case 'txndate':
               value = formatDate(transaction.txndate);
               break;
            case 'docnumber':
               value = transaction.docnumber ? String(transaction.docnumber) : '-';
               break;
            case 'daybookname':
               value = transaction.daybookname ? String(transaction.daybookname) : '-';
               break;
            case 'dueDays':
               // Show 0 if dueDays is 0, otherwise show the value or '-'
               value =
                  transaction.dueDays !== null && transaction.dueDays !== undefined ? String(transaction.dueDays) : '-';
               break;
            case 'txndays':
               // Show 0 if txndays is 0, otherwise show the value or '-'
               value =
                  transaction.txndays !== null && transaction.txndays !== undefined ? String(transaction.txndays) : '-';
               break;
            case 'netAmount':
               value = transaction.netAmount != null ? formatNumber(transaction.netAmount) : '-';
               break;
            case 'adjtxndate':
               value = transaction.adjtxndate ? formatDate(transaction.adjtxndate) : '-';
               break;
            case 'adjdaybookname':
               value = transaction.adjdaybookname ? String(transaction.adjdaybookname) : '-';
               break;
            case 'returnadjamount':
               value = transaction.returnadjamount != null ? formatNumber(transaction.returnadjamount) : '0.00';
               break;
            case 'otheradjamount':
               value = transaction.otheradjamount != null ? formatNumber(transaction.otheradjamount) : '0.00';
               break;
            case 'balanceamount':
               value = transaction.balanceamount != null ? formatNumber(transaction.balanceamount) : '-';
               break;
            default:
               // Handle any other field by converting to string
               value = transaction[columnId] != null ? String(transaction[columnId]) : '-';
               break;
         }

         // Final safety check - ensure the return value is always a string
         return String(value);
      };

      // Helper function to calculate totals based on visible columns
      const calculateTotals = (data, isCompany = false) => {
         let totals = {};
         const columns = calculateColumnLayout();

         columns.forEach((column) => {
            const columnId = column.id;

            if (['netAmount', 'returnadjamount', 'otheradjamount', 'balanceamount'].includes(columnId)) {
               if (isCompany) {
                  totals[columnId] = data.reduce((acc, accountData) => {
                     if (!accountData.data || !Array.isArray(accountData.data)) return acc;

                     if (columnId === 'netAmount' || columnId === 'balanceamount') {
                        const uniqueTransactions = accountData.data.filter(
                           (item, index, arr) => index === 0 || item.id !== arr[index - 1].id,
                        );
                        return acc + uniqueTransactions.reduce((sum, item) => sum + (Number(item[columnId]) || 0), 0);
                     } else {
                        return acc + accountData.data.reduce((sum, item) => sum + (Number(item[columnId]) || 0), 0);
                     }
                  }, 0);
               } else {
                  if (columnId === 'netAmount' || columnId === 'balanceamount') {
                     const uniqueTransactions = data.filter(
                        (item, index, arr) => index === 0 || item.id !== arr[index - 1].id,
                     );
                     totals[columnId] = uniqueTransactions.reduce(
                        (sum, item) => sum + (Number(item[columnId]) || 0),
                        0,
                     );
                  } else {
                     totals[columnId] = data.reduce((sum, item) => sum + (Number(item[columnId]) || 0), 0);
                  }
               }
            }
         });

         return totals;
      };

      // Draw table headers
      const drawTableHeaders = () => {
         if (headersDrawnOnPage) return;

         const columns = calculateColumnLayout();
         const headerHeight = 8; // Reduced header height

         doc.setFillColor(...styles.header.fillColor);
         doc.setTextColor(...styles.header.textColor);
         doc.setFont(undefined, styles.header.fontStyle);
         doc.setFontSize(8); // Ensure header font size is 8

         doc.rect(margin, currentY, pageWidth - margin * 2, headerHeight, 'F');

         columns.forEach((column) => {
            doc.text(
               column.header,
               column.align === 'right' ? column.x + column.width - 1 : column.x + 1,
               currentY + headerHeight / 2 + 2, // Better vertical centering
               { align: column.align },
            );
         });

         currentY += headerHeight;
         headersDrawnOnPage = true;
      };

      // Check if we have data to process
      if (!salesReport || salesReport.length === 0) {
         alert('No data available for PDF generation.');
         return;
      }

      // Main rendering
      salesReport.forEach((companyData, companyIndex) => {
         checkPageBreak(15);

         const companyTotals = calculateTotals(companyData.data || [], true);
         const columns = calculateColumnLayout();

         // Company Header
         doc.setFillColor(...styles.companyHeader.fillColor);
         doc.setTextColor(...styles.companyHeader.textColor);
         doc.setFont(undefined, styles.companyHeader.fontStyle);
         doc.setFontSize(8); // Set font size to 8

         const companyHeaderHeight = 8; // Reduced height
         doc.rect(margin, currentY, pageWidth - margin * 2, companyHeaderHeight, 'F');
         doc.text(companyData.companyName || 'Unknown Company', margin + 2, currentY + 5);

         // Company totals
         let totalsText = '';
         columns.forEach((column) => {
            if (companyTotals[column.id] !== undefined) {
               const label =
                  column.id === 'netAmount'
                     ? 'Net'
                     : column.id === 'returnadjamount'
                        ? 'Ret.Adj'
                        : column.id === 'otheradjamount'
                           ? 'Adj'
                           : column.id === 'balanceamount'
                              ? 'Balance'
                              : '';
               if (label) {
                  totalsText += `${label}: ${formatNumber(companyTotals[column.id])}  `;
               }
            }
         });

         if (totalsText) {
            doc.text(totalsText, pageWidth - margin - 2, currentY + 5, { align: 'right' });
         }
         currentY += companyHeaderHeight; // Reduced spacing

         // Process accounts
         if (companyData.data && Array.isArray(companyData.data)) {
            companyData.data.forEach((accountData, accountIndex) => {
               checkPageBreak(12);

               const partyTotals = calculateTotals(accountData.data || []);

               // Party Header
               doc.setFillColor(...styles.partyHeader.fillColor);
               doc.setTextColor(...styles.partyHeader.textColor);
               doc.setFont(undefined, styles.partyHeader.fontStyle);
               doc.setFontSize(8); // Set font size to 8

               const partyHeaderHeight = 7; // Reduced height
               doc.rect(margin, currentY, pageWidth - margin * 2, partyHeaderHeight, 'F');
               doc.text(`Party: ${accountData.accountName || 'Unknown Party'}`, margin + 2, currentY + 4);

               // Party totals
               let partyTotalsText = 'Total: ';
               columns.forEach((column) => {
                  if (partyTotals[column.id] !== undefined) {
                     const label =
                        column.id === 'netAmount'
                           ? 'Net'
                           : column.id === 'returnadjamount'
                              ? 'Ret.Adj'
                              : column.id === 'otheradjamount'
                                 ? 'Adj'
                                 : column.id === 'balanceamount'
                                    ? 'Balance'
                                    : '';
                     if (label) {
                        partyTotalsText += `${label}: ${formatNumber(partyTotals[column.id])}  `;
                     }
                  }
               });

               doc.text(partyTotalsText, pageWidth - margin - 2, currentY + 4, { align: 'right' });
               currentY += partyHeaderHeight; // Reduced spacing

               // Draw table headers if not already drawn on this page
               drawTableHeaders();

               // Process transactions
               if (accountData.data && Array.isArray(accountData.data)) {
                  let rowIndex = 0;
                  accountData.data.forEach((transaction, transIndex) => {
                     checkPageBreak(7); // Reduced height needed check

                     const isOddRow = rowIndex % 2 !== 0;
                     const style = isOddRow ? styles.oddRow : styles.evenRow;

                     doc.setFillColor(...style.fillColor);
                     const rowHeight = 7; // Reduced row height
                     doc.rect(margin, currentY, pageWidth - margin * 2, rowHeight, 'F');

                     columns.forEach((column) => {
                        const value = getCellValue(transaction, column.id);

                        doc.setTextColor(...column.styles.color);
                        doc.setFont(
                           undefined,
                           column.styles.isBold ? 'bold' : column.styles.isItalic ? 'italic' : 'normal',
                        );
                        doc.setFontSize(8); // Ensure font size is 8

                        doc.text(
                           value,
                           column.align === 'right' ? column.x + column.width - 1 : column.x + 1,
                           currentY + rowHeight / 2 + 2, // Better vertical centering
                           { align: column.align },
                        );
                     });

                     currentY += rowHeight;
                     rowIndex++;
                  });
               }

               currentY += 3; // Reduced spacing between accounts
            });
         }

         currentY += 5; // Reduced spacing between companies
      });

      // Save the PDF
      doc.save('outstanding_report.pdf');
   }, [
      salesReport,
      datePartyWiseSalesRange,
      companyFilter,
      companyList,
      columnVisibility,
      reportType,
      dynamicOptions,
      columnsReportsSalesDetail,
      textColor,
   ]);

   const calculateGrandTotals = useCallback(() => {
      if (!salesReport || salesReport.length === 0 || companyFilter.length <= 1) {
         return null;
      }

      let grandTotals = {
         netTotal: 0,
         returnAdjTotal: 0,
         otherAdjTotal: 0,
         balanceTotal: 0,
         totalTransactions: 0,
         companyCount: companyFilter.length,
      };

      salesReport.forEach((companyData) => {
         if (companyData.data && Array.isArray(companyData.data)) {
            companyData.data.forEach((accountData) => {
               if (accountData.data && Array.isArray(accountData.data)) {
                  // Count transactions
                  grandTotals.totalTransactions += accountData.data.length;

                  // Calculate unique transactions for netAmount and balanceAmount
                  const uniqueTransactions = accountData.data.filter(
                     (item, index, arr) => index === 0 || item.id !== arr[index - 1].id
                  );

                  // Net Amount (from unique transactions)
                  grandTotals.netTotal += uniqueTransactions.reduce(
                     (sum, item) => sum + (Number(item.netAmount) || 0), 0
                  );

                  // Return Adj Amount (from all transactions)
                  grandTotals.returnAdjTotal += accountData.data.reduce(
                     (sum, item) => sum + (Number(item.returnadjamount) || 0), 0
                  );

                  // Other Adj Amount (from all transactions)
                  grandTotals.otherAdjTotal += accountData.data.reduce(
                     (sum, item) => sum + (Number(item.otheradjamount) || 0), 0
                  );

                  // Balance Amount (from unique transactions)
                  grandTotals.balanceTotal += uniqueTransactions.reduce(
                     (sum, item) => sum + (Number(item.balanceamount) || Number(item.netAmount) || 0), 0
                  );
               }
            });
         }
      });

      return grandTotals;
   }, [salesReport, companyFilter]);

   const handleViewSingleData = async (id) => {
      await dispatch(getReceiveInventory(id));
      setIsOpenSingleViewinr(true);
   };
   const handleSalesSingleDataViewClose = () => setIsOpenSingleViewinr();

   const deletePurchaseReturn = () => {
      const selectedDaybook = daybookData.find((db) => db.id === viewDetail?.daybookId);
      if (entityType === 'purchasereturn') {
         if (selectedDaybook && selectedDaybook?.askPasswordOnDelete) {
            setDataId(viewDetail?.id);
            setIsModalOpen(true);
         } else {
            deleteRecord(
               viewDetail?.id,
               deletePurchaseReturnInvoice,
               dispatch,
               user?.loginhistory?.companyId,
               userGlobalSettingsData,
            );
         }
         // deleteRecord(viewDetail?.id, deletePurchaseReturnInvoice, dispatch, user?.loginhistory?.companyId, userGlobalSettingsData);
      }
      if (entityType === 'salereturn') {
         if (selectedDaybook && selectedDaybook?.askPasswordOnDelete) {
            setDataId(viewDetail?.id);
            setIsModalOpen(true);
         } else {
            deleteRecord(
               viewDetail?.id,
               deleteSaleReturnInvoice,
               dispatch,
               user?.loginhistory?.companyId,
               userGlobalSettingsData,
            );
         }
         // deleteRecord(viewDetail?.id, deleteSaleReturnInvoice, dispatch, user?.loginhistory?.companyId, userGlobalSettingsData);
      }
      if (entityType === 'saleinvoice') {
         if (selectedDaybook && selectedDaybook?.askPasswordOnDelete) {
            setDataId({ id: viewDetail?.id, daybookId: viewDetail.daybookId, accountId: viewDetail.accountId });
            setIsModalOpen(true);
         } else {
            deleteRecordForSales(
               viewDetail?.id,
               viewDetail?.daybookId,
               viewDetail?.accountId,
               deleteSaleInvoice,
               dispatch,
               storedCompanyId,
               userGlobalSettingsData,
            );
         }
         // deleteRecordForSales(
         //    viewDetail?.id,
         //    viewDetail?.daybookId,
         //    viewDetail?.accountId,
         //    deleteSaleInvoice,
         //    dispatch,
         //    storedCompanyId,
         //    userGlobalSettingsData,
         // );
      }
      if (entityType === 'purchaseinvoice') {
         // deleteRecordForSales(
         //    viewDetail?.id,
         //    viewDetail?.daybookId,
         //    viewDetail?.accountId,
         //    deletePurchaseInvoice,
         //    dispatch,
         //    storedCompanyId,
         //    userGlobalSettingsData,
         // );
         if (selectedDaybook && selectedDaybook?.askPasswordOnDelete) {
            setDataId({ id: viewDetail?.id, daybookId: viewDetail.daybookId, accountId: viewDetail.accountId });
            setIsModalOpen(true);
         } else {
            deleteRecordForSales(
               viewDetail?.id,
               viewDetail.daybookId,
               viewDetail.accountId,
               deletePurchaseInvoice,
               dispatch,
               user?.loginhistory?.companyId,
               userGlobalSettingsData,
            );
         }
      }
      setIsOpenPurchaseReturnSingleView(false);
   };

   const handleSalesDetailsClose = () => setIsOpenPurchaseReturnSingleView();

   useEffect(() => {
      if (account) {
         setDynamicUserDetails([
            { label: 'Bill To', value: account?.name || '-' },
            { label: 'Mobile', value: account?.mobile || '-' },
            { label: 'PAN', value: account?.panNo || '-' },
            { label: 'Billing Address', value: account?.address || '-' },
         ]);
      }
   }, [account]);

   const storedCompanyId = localStorage.getItem('companyId');

   const formatNumberWithSmallDecimal = useCallback((number) => {
      if (number === null || number === undefined || number === '') return '-';
      const numValue = Number(number);
      if (isNaN(numValue)) return String(number);
      const formatted = numValue.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const parts = formatted.split('.');
      if (parts.length === 2) {
         return (
            <>
               {parts[0]}.<span style={{ fontSize: '10px' }}>{parts[1]}</span>
            </>
         );
      }
      return formatted;
   }, []);

   const formatNumberWithSmallDecimalZero = useCallback((number) => {
      if (number === null || number === undefined || number === '' || number === 0) return '0.00';
      const numValue = Number(number);
      if (isNaN(numValue)) return String(number);
      const formatted = numValue.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const parts = formatted.split('.');
      if (parts.length === 2) {
         return (
            <>
               {parts[0]}.<span style={{ fontSize: '10px' }}>{parts[1]}</span>
            </>
         );
      }
      return formatted;
   }, []);

   const renderDataRows = useCallback(
      (itemData, formatData) => {
         if (!itemData || !Array.isArray(itemData)) return [];

         return itemData.map((transaction, rowIndex) => {
            const previousTransaction = rowIndex > 0 ? itemData[rowIndex - 1] : null;
            const isSameId = previousTransaction && transaction.id === previousTransaction.id;
            const isOddRow = rowIndex % 2 !== 0;

            const handledata = async (data) => {
               const companyId = parseInt(storedCompanyId);
               setIsModalLoading(true);
               try {
                  if (companyId === data.companyId && data.daybooktype === 20 && (admin || rights?.inventoryreceive?.view)) {
                     setEntityType('receivemaster');
                     const r = await dispatch(getReceiveInventory(data.id));
                     await dispatch(getAccountById({ id: r?.accountId, compId: user?.loginhistory?.companyId }));
                     setIsOpenSingleViewinr(true);
                  }
                  if (companyId === data.companyId && data.daybooktype === 19 && (admin || rights?.inventoryissue?.view)) {
                     setEntityType('issuemaster');
                     const r = await dispatch(getIssueInventory(data.id));
                     await dispatch(getAccountById({ id: r?.accountId, compId: user?.loginhistory?.companyId }));
                     setIsOpenSingleViewinr(true);
                  }
                  if (companyId === data.companyId && data.daybooktype === 11 && (admin || rights?.purchaseinvoice?.view)) {
                     setEntityType('purchaseinvoice');
                     await dispatch(
                        getSinglePurchaseWithPrevAndNext({
                           id: data.id,
                           page: 1,
                           limit: 1,
                           sortBy: 'id',
                           sortOrder: 'desc',
                        }),
                     );
                     setIsOpenPurchaseReturnSingleView(true);
                  }
                  if (companyId === data.companyId && data.daybooktype === 5 && (admin || rights?.saleinvoice?.view)) {
                     setEntityType('saleinvoice');
                     await dispatch(getSaleInvoice(data.id));
                     setIsOpenPurchaseReturnSingleView(true);
                  }
                  if (companyId === data.companyId && data.daybooktype === 12 && (admin || rights?.purchasereturn?.view)) {
                     setEntityType('purchasereturn');
                     await dispatch(getSinglePurchaseReturn(data.id));
                     setIsOpenPurchaseReturnSingleView(true);
                  }
                  if (companyId === data.companyId && data.daybooktype === 6 && (admin || rights?.salereturn?.view)) {
                     setEntityType('salereturn');
                     await dispatch(
                        getSingleSalesReturnWithPrevAndNext({
                           id: data.id,
                           page: 1,
                           limit: 1,
                           sortBy: 'id',
                           sortOrder: 'desc',
                        }),
                     );
                     setIsOpenPurchaseReturnSingleView(true);
                  }
                  if (companyId === data.companyId && data.daybooktype === 13 && (admin || rights?.cashPayment?.view || rights?.cashReceive?.view)) {
                     setEntityType('cash');
                     setIsBankPageTrue(false);
                     await dispatch(getOneVoucher(data.id));
                     setIsOpenSingleViewcnb(true);
                  }
                  if (companyId === data.companyId && data.daybooktype === 14 && (admin || rights?.bankPayment?.view || rights?.bankReceive?.view)) {
                     setEntityType('bank');
                     setIsBankPageTrue(true);
                     await dispatch(getOneVoucher(data.docid));
                     setIsOpenSingleViewcnb(true);
                  }
                  setTimeout(() => setIsModalLoading(false), 100);
               } catch (error) {
                  console.error('Error loading single view data:', error);
                  setIsModalLoading(false);
               }
            };

            const convertBackendColor = (backendColor) => {
               if (!backendColor) return null;
               if (backendColor.startsWith('#')) return backendColor;
               if (backendColor.startsWith('0xff')) return '#' + backendColor.substring(4);
               if (/^[0-9A-Fa-f]{6}$/.test(backendColor)) return '#' + backendColor;
               return backendColor;
            };

            const formatCellContent = (value, isNumericColumn) => {
               if (isNumericColumn && value !== null && value !== undefined && value !== '') {
                  if (typeof value === 'number' || !isNaN(value)) return formatNumberWithSmallDecimal(value);
               }
               return value;
            };

            if (formatData) {
               const viewJson = formatData?.viewJson || null;
               return (
                  <tr
                     key={`row-${transaction.id || rowIndex}`}
                     style={{
                        display: 'table',
                        width: '100%',
                        tableLayout: 'fixed',
                        borderBottom: '1px solid #ccc',
                        background: isOddRow ? 'rgba(0, 63, 140, 0.05)' : 'transparent',
                        cursor: 'pointer',
                        fontSize: '12px',
                        fontWeight: 500,
                     }}
                     onClick={() => handledata(transaction)}>
                     {visibleColDefs.map((colDef, index) => {
                        const item = viewJson?.find((v) => v.defName === colDef.id);
                        let cellContent = '-';
                        const defName = colDef.id;

                        if (defName === 'net_amount') cellContent = transaction.netAmount;
                        else if (defName === 'v.no.') cellContent = transaction.docnumber;
                        else if (defName === 'due_days')
                           cellContent =
                              transaction.dueDays !== null && transaction.dueDays !== 0 ? transaction.dueDays : '';
                        else if (defName === 'date')
                           cellContent = transaction.txndate
                              ? new Date(transaction.txndate).toLocaleDateString('en-IN')
                              : '-';
                        else if (defName === 'rec._date')
                           cellContent = transaction.adjtxndate
                              ? new Date(transaction.adjtxndate).toLocaleDateString('en-IN')
                              : '-';
                        else if (defName === 'rec._book') cellContent = transaction.adjdaybookname || '-';
                        else if (defName === 'ret._adj._amt.') cellContent = transaction.returnadjamount;
                        else if (defName === 'adj._amt.') cellContent = transaction.otheradjamount;
                        else if (defName === 'os._amt') cellContent = transaction.balanceamount;
                        else if (defName === 'daybook.name') cellContent = transaction.daybookname || '-';
                        else if (defName === 'txn_days') cellContent = transaction.txndays;

                        return (
                           <td
                              key={index}
                              style={{
                                 width: colDef.flexPct,
                                 padding: '4px 8px',
                                 fontSize: '12px',
                                 fontWeight: colDef.isBold ? 'bold' : 'normal',
                                 fontStyle: colDef.isItalic ? 'italic' : 'normal',
                                 textAlign: colDef.align,
                                 color: convertBackendColor(colDef.color) || 'inherit',
                                 whiteSpace: 'nowrap',
                                 overflow: 'hidden',
                                 textOverflow: 'ellipsis',
                                 verticalAlign: 'middle',
                              }}>
                              {cellContent}
                           </td>
                        );
                     })}
                  </tr>
               );
            }

            return (
               <tr
                  key={`row-${transaction.id || rowIndex}`}
                  style={{
                     display: 'table',
                     width: '100%',
                     tableLayout: 'fixed',
                     borderBottom: '1px solid #ccc',
                     background: isOddRow ? 'rgba(0, 63, 140, 0.05)' : 'transparent',
                     cursor: 'pointer',
                     fontSize: '12px',
                     fontWeight: 500,
                  }}
                  onClick={() => handledata(transaction)}>
                  {visibleColDefs.map((colDef) => {
                     const columnId = colDef.id;
                     const isNumericColumn = [
                        'netAmount',
                        'dueDays',
                        'returnadjamount',
                        'otheradjamount',
                        'balanceamount',
                     ].includes(columnId);
                     let cellContent = '-';

                     if (!isSameId || columnId === 'returnadjamount' || columnId === 'otheradjamount') {
                        switch (columnId) {
                           case 'txndate':
                              cellContent = transaction.txndate
                                 ? new Date(transaction.txndate).toLocaleDateString('en-IN')
                                 : '-';
                              break;
                           case 'docnumber':
                              cellContent = transaction.docnumber || '-';
                              break;
                           case 'dueDays':
                              cellContent = transaction.dueDays;
                              break;
                           case 'txndays':
                              cellContent = transaction.txndays;
                              break;
                           case 'netAmount':
                              cellContent = formatCellContent(transaction.netAmount, true);
                              break;
                           case 'adjtxndate':
                              cellContent = transaction.adjtxndate
                                 ? new Date(transaction.adjtxndate).toLocaleDateString('en-IN')
                                 : '-';
                              break;
                           case 'adjdaybookname':
                              cellContent = transaction.adjdaybookname || '-';
                              break;
                           case 'returnadjamount':
                              cellContent = formatCellContent(transaction.returnadjamount, true);
                              break;
                           case 'otheradjamount':
                              cellContent = formatCellContent(transaction.otheradjamount, true);
                              break;
                           case 'balanceamount':
                              cellContent = formatCellContent(transaction.balanceamount, true);
                              break;
                           default:
                              cellContent = transaction[columnId] || '-';
                        }
                     }

                     return (
                        <td
                           key={columnId}
                           style={{
                              width: colDef.flexPct,
                              padding: '2px 8px',
                              fontSize: '14px',
                              textAlign: colDef.align,
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              verticalAlign: 'middle',
                           }}>
                           {cellContent}
                        </td>
                     );
                  })}
               </tr>
            );
         });
      },
      [dispatch, user?.loginhistory?.companyId, textColor, visibleColDefs, formatNumberWithSmallDecimal],
   );

   const generateFlatRows = useCallback(() => {
      const rows = [];

      if (isLoading) {
         return [{ type: 'loader', key: 'loader' }];
      }
      if (!salesReport || salesReport.length === 0) {
         return [{ type: 'noData', key: 'noData' }];
      }

      const grandTotals = calculateGrandTotals();
      if (grandTotals) {
         rows.push({
            type: 'grandTotal',
            data: grandTotals,
            key: 'grand-total-top',
         });
      }

      const isDynamicType = dynamicValues && dynamicValues.includes(reportType);

      if (isDynamicType) {
         const selectedFormat = dynamicOptions.find((opt) => opt.value === reportType);
         const formatData = selectedFormat?.formatData;
         const defName = selectedFormat?.formatData?.defName;

         const isOutstandingDate = defName === 'OutstandingDate' || defName === 'OutstandingBroker';
         const isOutstandingParty = defName === 'OutstandingParty';

         if (isOutstandingDate) {
            salesReport.forEach((dateItem) => {
               if (dateItem.data && Array.isArray(dateItem.data)) {
                  dateItem.data.forEach((item) => {
                     if (item.data && Array.isArray(item.data)) {
                        item.data.forEach((transaction, idx) => {
                           rows.push({
                              type: 'dataRow',
                              transaction,
                              formatData,
                              isOdd: idx % 2 !== 0,
                              key: `dr-${transaction.id}-${idx}`,
                           });
                        });
                        const uniqueData = item.data.filter((d, i, arr) => i === 0 || d.id !== arr[i - 1].id);
                        rows.push({
                           type: 'totalRow',
                           formatData,
                           totals: {
                              netAmount: uniqueData.reduce((s, d) => s + (Number(d.netAmount) || 0), 0),
                              returnAdj: item.data.reduce((s, d) => s + (Number(d.returnadjamount) || 0), 0),
                              otherAdj: item.data.reduce((s, d) => s + (Number(d.otheradjamount) || 0), 0),
                              balanceAmount: uniqueData.reduce((s, d) => s + (Number(d.balanceamount) || 0), 0),
                           },
                           key: `total-${Date.now()}-${Math.random()}`,
                        });
                     }
                  });
               }
            });
         }

         if (isOutstandingParty) {
            salesReport.forEach((companyData) => {
               const companyKey = `company-${companyData.companyId}`;
               const isExpanded = expandedItems[companyKey] !== false;

               // Grand totals for company
               const grandTotals = companyData.data?.reduce(
                  (acc, accountData) => {
                     if (!accountData.data) return acc;
                     const unique = accountData.data.filter((it, i, arr) => i === 0 || it.id !== arr[i - 1].id);
                     return {
                        netTotal: acc.netTotal + unique.reduce((s, it) => s + (Number(it.netAmount) || 0), 0),
                        returnAdjTotal:
                           acc.returnAdjTotal +
                           accountData.data.reduce((s, it) => s + (Number(it.returnadjamount) || 0), 0),
                        otherAdjTotal:
                           acc.otherAdjTotal +
                           accountData.data.reduce((s, it) => s + (Number(it.otheradjamount) || 0), 0),
                        balanceTotal:
                           acc.balanceTotal +
                           unique.reduce((s, it) => s + (Number(it.balanceamount) || Number(it.netAmount) || 0), 0),
                     };
                  },
                  { netTotal: 0, returnAdjTotal: 0, otherAdjTotal: 0, balanceTotal: 0 },
               ) || { netTotal: 0, returnAdjTotal: 0, otherAdjTotal: 0, balanceTotal: 0 };

               rows.push({
                  type: 'dynamicCompanyHeader',
                  companyData,
                  formatData,
                  grandTotals,
                  companyKey,
                  isExpanded,
                  key: `co-${companyData.companyId}`,
               });

               if (isExpanded && companyData.data) {
                  companyData.data.forEach((accountData) => {
                     const accountKey = `account-${accountData.accountId}`;
                     const isAccExpanded = expandedItems[accountKey] !== false;

                     const unique = accountData.data?.filter((it, i, arr) => i === 0 || it.id !== arr[i - 1].id) || [];
                     const accountTotals = {
                        netTotal: unique.reduce((s, it) => s + (Number(it.netAmount) || 0), 0),
                        returnAdjTotal:
                           accountData.data?.reduce((s, it) => s + (Number(it.returnadjamount) || 0), 0) || 0,
                        otherAdjTotal:
                           accountData.data?.reduce((s, it) => s + (Number(it.otheradjamount) || 0), 0) || 0,
                        balanceTotal: unique.reduce(
                           (s, it) => s + (Number(it.balanceamount) || Number(it.netAmount) || 0),
                           0,
                        ),
                     };

                     rows.push({
                        type: 'dynamicAccountHeader',
                        accountData,
                        formatData,
                        accountTotals,
                        accountKey,
                        isExpanded: isAccExpanded,
                        key: `ac-${accountData.accountId}`,
                     });

                     if (isAccExpanded && accountData.data) {
                        accountData.data.forEach((transaction, idx) => {
                           rows.push({
                              type: 'dataRow',
                              transaction,
                              formatData,
                              isOdd: idx % 2 !== 0,
                              key: `dr2-${transaction.id}-${idx}`,
                           });
                        });
                     }
                  });
               }
            });
         }
      } else if (reportType === REPORT_TYPE.party) {
         salesReport.forEach((companyData) => {
            const companyKey = `company-${companyData.companyId}`;
            const isExpanded = expandedItems[companyKey] !== false;

            const grandTotals = companyData.data?.reduce(
               (acc, accountData) => {
                  if (!accountData.data) return acc;
                  const unique = accountData.data.filter((it, i, arr) => i === 0 || it.id !== arr[i - 1].id);
                  return {
                     netTotal: acc.netTotal + unique.reduce((s, it) => s + (Number(it.netAmount) || 0), 0),
                     returnAdjTotal:
                        acc.returnAdjTotal +
                        accountData.data.reduce((s, it) => s + (Number(it.returnadjamount) || 0), 0),
                     otherAdjTotal:
                        acc.otherAdjTotal + accountData.data.reduce((s, it) => s + (Number(it.otheradjamount) || 0), 0),
                     balanceTotal:
                        acc.balanceTotal +
                        unique.reduce((s, it) => s + (Number(it.balanceamount) || Number(it.netAmount) || 0), 0),
                  };
               },
               { netTotal: 0, returnAdjTotal: 0, otherAdjTotal: 0, balanceTotal: 0 },
            ) || { netTotal: 0, returnAdjTotal: 0, otherAdjTotal: 0, balanceTotal: 0 };

            rows.push({
               type: 'staticCompanyHeader',
               companyData,
               grandTotals,
               companyKey,
               isExpanded,
               key: `sco-${companyData.companyId}`,
            });

            if (isExpanded && companyData.data) {
               companyData.data.forEach((accountData) => {
                  const accountKey = `account-${accountData.accountId}`;
                  const isAccExpanded = expandedItems[accountKey] !== false;

                  const unique = accountData.data?.filter((it, i, arr) => i === 0 || it.id !== arr[i - 1].id) || [];
                  const accountTotals = {
                     netTotal: unique.reduce((s, it) => s + (Number(it.netAmount) || 0), 0),
                     returnAdjTotal: accountData.data?.reduce((s, it) => s + (Number(it.returnadjamount) || 0), 0) || 0,
                     otherAdjTotal: accountData.data?.reduce((s, it) => s + (Number(it.otheradjamount) || 0), 0) || 0,
                     balanceTotal: unique.reduce(
                        (s, it) => s + (Number(it.balanceamount) || Number(it.netAmount) || 0),
                        0,
                     ),
                  };

                  rows.push({
                     type: 'staticAccountHeader',
                     accountData,
                     accountTotals,
                     accountKey,
                     isExpanded: isAccExpanded,
                     key: `sac-${accountData.accountId}`,
                  });

                  if (isAccExpanded && accountData.data) {
                     accountData.data.forEach((transaction, idx) => {
                        rows.push({
                           type: 'dataRow',
                           transaction,
                           formatData: null,
                           isOdd: idx % 2 !== 0,
                           key: `sdr-${transaction.id}-${idx}`,
                        });
                     });
                  }
               });
            }
         });
      } else {
         // date / broker static
         salesReport.forEach((dateItem) => {
            if (dateItem.data && Array.isArray(dateItem.data)) {
               dateItem.data.forEach((item) => {
                  if (item.data && Array.isArray(item.data)) {
                     item.data.forEach((transaction, idx) => {
                        rows.push({
                           type: 'dataRow',
                           transaction,
                           formatData: null,
                           isOdd: idx % 2 !== 0,
                           key: `ddr-${transaction.id}-${idx}`,
                        });
                     });
                     const unique = item.data.filter((d, i, arr) => i === 0 || d.id !== arr[i - 1].id);
                     rows.push({
                        type: 'staticTotalRow',
                        totals: {
                           netAmount: unique.reduce((s, d) => s + (Number(d.netAmount) || 0), 0),
                           returnAdj: item.data.reduce((s, d) => s + (Number(d.returnadjamount) || 0), 0),
                           otherAdj: item.data.reduce((s, d) => s + (Number(d.otheradjamount) || 0), 0),
                           balanceAmount: unique.reduce((s, d) => s + (Number(d.balanceamount) || 0), 0),
                        },
                        key: `stot-${Date.now()}-${Math.random()}`,
                     });
                  }
               });
            }
         });
      }

      return rows;
   }, [salesReport, isLoading, dynamicValues, reportType, dynamicOptions, expandedItems]);

   const flatRowsRef = useRef([]);
   const flatRows = useMemo(() => {
      const rows = generateFlatRows();
      flatRowsRef.current = rows;
      return rows;
   }, [generateFlatRows]);

   const listRef = useRef(null);
   useEffect(() => {
      if (listRef.current) listRef.current.resetAfterIndex(0);
   }, [flatRows]);

   const getItemSize = useCallback((index) => {
      const row = flatRowsRef.current[index];
      if (!row) return 35;
      if (row.type === 'loader' || row.type === 'noData') return 200;
      if (row.type === 'grandTotal') return 45;
      if (row.type === 'staticCompanyHeader' || row.type === 'dynamicCompanyHeader') return 38;
      if (row.type === 'staticAccountHeader' || row.type === 'dynamicAccountHeader') return 36;
      if (row.type === 'totalRow' || row.type === 'staticTotalRow') return 32;
      return 34;
   }, []);

   const VirtualRow = useCallback(
      ({ index, style }) => {
         const row = flatRowsRef.current[index];
         if (!row) return null;

         const tdBase = {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            padding: '4px 8px',
            verticalAlign: 'middle',
            fontSize: '13px',
         };

         const rowWrap = (content, bgColor = 'transparent') => (
            <div
               style={{
                  ...style,
                  width: '100%',
                  display: 'table',
                  tableLayout: 'fixed',
                  background: bgColor,
                  borderBottom: '1px solid #e2e8f0',
               }}>
               {content}
            </div>
         );

         if (row.type === 'loader') {
            return (
               <div
                  style={{ ...style, width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Loader />
               </div>
            );
         }

         if (row.type === 'noData') {
            return (
               <div
                  style={{
                     ...style,
                     width: '100%',
                     display: 'flex',
                     flexDirection: 'column',
                     alignItems: 'center',
                     justifyContent: 'center',
                     padding: '40px',
                  }}>
                  <img src={nodata} alt="No Data Found" width="200px" height="200px" />
                  <label>No outstanding data found</label>
               </div>
            );
         }
         if (row.type === 'grandTotal') {
            const totals = row.data;
            return (
               <div style={style}>
                  <div
                     style={{
                        display: 'table',
                        width: '100%',
                        tableLayout: 'fixed',
                        background: isDark
                           ? 'linear-gradient(90deg, #0b3b2c, #1e4b3a, #0b3b2c)'
                           : 'linear-gradient(90deg, #d1fae5, #a7f3d0, #d1fae5)',
                        borderTop: `3px solid ${isDark ? '#10b981' : '#059669'}`,
                        borderBottom: `3px solid ${isDark ? '#10b981' : '#059669'}`,
                        fontWeight: 700,
                        height: '100%',
                        boxShadow: isDark ? '0 2px 8px rgba(16,185,129,0.2)' : '0 2px 8px rgba(5,150,105,0.1)',
                     }}>
                     <div style={{ display: 'table-row' }}>
                        {visibleColDefs.map((colDef, index) => {
                           let cellValue = '';
                           const tdStyle = {
                              display: 'table-cell',
                              width: colDef.flexPct,
                              padding: '8px 8px',
                              verticalAlign: 'middle',
                              fontSize: '13px',
                              fontWeight: 700,
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              color: isDark ? '#d1fae5' : '#064e3b',
                           };

                           if (index === 0) {
                              cellValue = `GRAND TOTAL (${totals.companyCount} Companies)`;
                           } else if (colDef.id === 'netAmount' || colDef.id === 'net_amount') {
                              cellValue = formatNumberWithSmallDecimalZero(totals.netTotal);
                              tdStyle.textAlign = 'right';
                           } else if (colDef.id === 'returnadjamount' || colDef.id === 'ret._adj._amt.') {
                              cellValue = formatNumberWithSmallDecimalZero(totals.returnAdjTotal);
                              tdStyle.textAlign = 'right';
                           } else if (colDef.id === 'otheradjamount' || colDef.id === 'adj._amt.') {
                              cellValue = formatNumberWithSmallDecimalZero(totals.otherAdjTotal);
                              tdStyle.textAlign = 'right';
                           } else if (colDef.id === 'balanceamount' || colDef.id === 'os._amt') {
                              cellValue = formatNumberWithSmallDecimalZero(totals.balanceTotal);
                              tdStyle.textAlign = 'right';
                           } else if (colDef.id === 'dueDays' || colDef.id === 'txndays') {
                              tdStyle.textAlign = 'right';
                           } else {
                              tdStyle.textAlign = index === 0 ? 'left' : colDef.align || 'left';
                           }

                           // Add transaction count badge for first column
                           if (index === 0) {
                              return (
                                 <div key={index} style={tdStyle}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                       <span>{cellValue}</span>
                                       <span style={{
                                          padding: '2px 8px',
                                          borderRadius: '12px',
                                          fontSize: '11px',
                                          fontWeight: 600,
                                          background: isDark ? 'rgba(16,185,129,0.2)' : 'white',
                                          color: isDark ? '#a7f3d0' : '#065f46',
                                          border: `1px solid ${isDark ? '#10b981' : '#a7f3d0'}`,
                                       }}>
                                          {totals.totalTransactions} Transactions
                                       </span>
                                    </div>
                                 </div>
                              );
                           }

                           return (
                              <div key={index} style={tdStyle}>
                                 {cellValue || '-'}
                              </div>
                           );
                        })}
                     </div>
                  </div>
               </div>
            );
         }
         if (row.type === 'dataRow') {
            const rendered = renderDataRows([row.transaction], row.formatData);
            return (
               <div style={{ ...style, width: '100%' }}>
                  <table style={{ width: '100%', tableLayout: 'fixed', borderCollapse: 'collapse' }}>
                     <tbody>{rendered}</tbody>
                  </table>
               </div>
            );
         }

         if (row.type === 'totalRow') {
            const { totals, formatData } = row;
            const viewJson = formatData?.viewJson?.filter((i) => i.isShow) || [];
            return rowWrap(
               <div style={{ display: 'table-row' }}>
                  {visibleColDefs.map((colDef, index) => {
                     const defName = colDef.id;
                     let cellValue = '';
                     if (defName === 'date') cellValue = 'Total :';
                     else if (defName === 'net_amount') cellValue = formatNumberWithSmallDecimalZero(totals.netAmount);
                     else if (defName === 'ret._adj._amt.')
                        cellValue = formatNumberWithSmallDecimalZero(totals.returnAdj);
                     else if (defName === 'adj._amt.') cellValue = formatNumberWithSmallDecimalZero(totals.otherAdj);
                     else if (defName === 'os._amt') cellValue = formatNumberWithSmallDecimalZero(totals.balanceAmount);
                     return (
                        <div
                           key={index}
                           style={{
                              ...tdBase,
                              display: 'table-cell',
                              width: colDef.flexPct,
                              textAlign: colDef.align,
                              fontWeight: 600,
                              color: 'brown',
                           }}>
                           {cellValue}
                        </div>
                     );
                  })}
               </div>,
               '#f5f5f5',
            );
         }

         if (row.type === 'staticTotalRow') {
            const { totals } = row;
            return rowWrap(
               <div style={{ display: 'table-row' }}>
                  {visibleColDefs.map((colDef, index) => {
                     let cellValue = '';
                     if (index === 0) cellValue = 'Total :';
                     else if (colDef.id === 'netAmount') cellValue = formatNumberWithSmallDecimalZero(totals.netAmount);
                     else if (colDef.id === 'returnadjamount')
                        cellValue = formatNumberWithSmallDecimalZero(totals.returnAdj);
                     else if (colDef.id === 'otheradjamount')
                        cellValue = formatNumberWithSmallDecimalZero(totals.otherAdj);
                     else if (colDef.id === 'balanceamount')
                        cellValue = formatNumberWithSmallDecimalZero(totals.balanceAmount);
                     return (
                        <div
                           key={index}
                           style={{
                              ...tdBase,
                              display: 'table-cell',
                              width: colDef.flexPct,
                              textAlign: index === 0 ? 'left' : colDef.align,
                              fontWeight: 600,
                              color: isDark ? '#fff' : '#000',
                              backgroundColor: isDark ? '#182747' : '#f5f5f5',
                           }}>
                           {cellValue}
                        </div>
                     );
                  })}
               </div>,
            );
         }

         if (row.type === 'dynamicCompanyHeader') {
            const { companyData, grandTotals, companyKey, isExpanded } = row;
            return rowWrap(
               <div style={{ display: 'table-row' }}>
                  {visibleColDefs.map((colDef, index) => {
                     let cellValue = '';
                     if (index === 0) cellValue = companyData.companyName || '';
                     else if (colDef.id === 'net_amount')
                        cellValue = formatNumberWithSmallDecimalZero(grandTotals.netTotal);
                     else if (colDef.id === 'ret._adj._amt.')
                        cellValue = formatNumberWithSmallDecimalZero(grandTotals.returnAdjTotal);
                     else if (colDef.id === 'adj._amt.')
                        cellValue = formatNumberWithSmallDecimalZero(grandTotals.otherAdjTotal);
                     else if (colDef.id === 'os._amt')
                        cellValue = (
                           <Flex justify="flex-end" align="center" gap={1}>
                              {formatNumberWithSmallDecimalZero(grandTotals.balanceTotal)}
                              <IconButton
                                 icon={isExpanded ? <ChevronDownIcon /> : <ChevronUpIcon />}
                                 size="xs"
                                 onClick={(e) => {
                                    e.stopPropagation();
                                    toggleExpand(companyKey);
                                 }}
                                 aria-label="toggle"
                              />
                           </Flex>
                        );
                     return (
                        <div
                           key={index}
                           style={{
                              ...tdBase,
                              display: 'table-cell',
                              width: colDef.flexPct,
                              textAlign: index === 0 ? 'left' : colDef.align,
                              fontWeight: 700,
                              color: isDark ? '#fff' : '#000',
                              backgroundColor: isDark ? '#16213E' : '#E6E6E6',
                              fontSize: '14px',
                           }}>
                           {cellValue}
                        </div>
                     );
                  })}
               </div>,
            );
         }

         if (row.type === 'staticCompanyHeader') {
            const { companyData, grandTotals, companyKey, isExpanded } = row;
            return rowWrap(
               <div style={{ display: 'table-row' }}>
                  {visibleColDefs.map((colDef, index) => {
                     let cellValue = '';
                     if (index === 0) cellValue = companyData.companyName || '';
                     else if (colDef.id === 'netAmount')
                        cellValue = formatNumberWithSmallDecimalZero(grandTotals.netTotal);
                     else if (colDef.id === 'returnadjamount')
                        cellValue = formatNumberWithSmallDecimalZero(grandTotals.returnAdjTotal);
                     else if (colDef.id === 'otheradjamount')
                        cellValue = formatNumberWithSmallDecimalZero(grandTotals.otherAdjTotal);
                     else if (colDef.id === 'balanceamount')
                        cellValue = (
                           <Flex justify="flex-end" align="center" gap={1}>
                              {formatNumberWithSmallDecimalZero(grandTotals.balanceTotal)}
                              <IconButton
                                 icon={isExpanded ? <ChevronDownIcon /> : <ChevronUpIcon />}
                                 size="xs"
                                 onClick={(e) => {
                                    e.stopPropagation();
                                    toggleExpand(companyKey);
                                 }}
                                 aria-label="toggle"
                              />
                           </Flex>
                        );
                     return (
                        <div
                           key={index}
                           style={{
                              ...tdBase,
                              display: 'table-cell',
                              width: colDef.flexPct,
                              textAlign: index === 0 ? 'left' : colDef.align,
                              fontWeight: 700,
                              color: isDark ? '#fff' : '#000',
                              backgroundColor: isDark ? '#16213E' : '#E6E6E6',
                              fontSize: '15px',
                           }}>
                           {cellValue}
                        </div>
                     );
                  })}
               </div>,
            );
         }

         if (row.type === 'dynamicAccountHeader') {
            const { accountData, accountTotals, accountKey, isExpanded } = row;
            return rowWrap(
               <div style={{ display: 'table-row' }}>
                  {visibleColDefs.map((colDef, index) => {
                     let cellValue = '';
                     if (index === 0) cellValue = `Party : ${accountData.accountName}`;
                     else if (index === 1) cellValue = 'Total :';
                     else if (colDef.id === 'net_amount')
                        cellValue = formatNumberWithSmallDecimalZero(accountTotals.netTotal);
                     else if (colDef.id === 'ret._adj._amt.')
                        cellValue = formatNumberWithSmallDecimalZero(accountTotals.returnAdjTotal);
                     else if (colDef.id === 'adj._amt.')
                        cellValue = formatNumberWithSmallDecimalZero(accountTotals.otherAdjTotal);
                     else if (colDef.id === 'os._amt')
                        cellValue = (
                           <Flex justify="flex-end" align="center" gap={1}>
                              {formatNumberWithSmallDecimalZero(accountTotals.balanceTotal)}
                              <IconButton
                                 icon={isExpanded ? <ChevronDownIcon /> : <ChevronUpIcon />}
                                 size="xs"
                                 onClick={(e) => {
                                    e.stopPropagation();
                                    toggleExpand(accountKey);
                                 }}
                                 aria-label="toggle"
                              />
                           </Flex>
                        );
                     return (
                        <div
                           key={index}
                           style={{
                              ...tdBase,
                              display: 'table-cell',
                              width: colDef.flexPct,
                              textAlign: index === 0 ? 'left' : colDef.align,
                              fontWeight: 600,
                              color: '#2A3335',
                              fontSize: '13px',
                           }}>
                           {cellValue}
                        </div>
                     );
                  })}
               </div>,
            );
         }

         if (row.type === 'staticAccountHeader') {
            const { accountData, accountTotals, accountKey, isExpanded } = row;
            return rowWrap(
               <div style={{ display: 'table-row' }}>
                  {visibleColDefs.map((colDef, index) => {
                     let cellValue = '';
                     if (index === 0) cellValue = `Party : ${accountData.accountName}`;
                     else if (colDef.id === 'netAmount' && index === 2) cellValue = 'Total :';
                     else if (colDef.id === 'netAmount')
                        cellValue = formatNumberWithSmallDecimalZero(accountTotals.netTotal);
                     else if (colDef.id === 'returnadjamount')
                        cellValue = formatNumberWithSmallDecimalZero(accountTotals.returnAdjTotal);
                     else if (colDef.id === 'otheradjamount')
                        cellValue = formatNumberWithSmallDecimalZero(accountTotals.otherAdjTotal);
                     else if (colDef.id === 'balanceamount')
                        cellValue = (
                           <Flex justify="flex-end" align="center" gap={1}>
                              {formatNumberWithSmallDecimalZero(accountTotals.balanceTotal)}
                              <IconButton
                                 icon={isExpanded ? <ChevronDownIcon /> : <ChevronUpIcon />}
                                 size="xs"
                                 onClick={(e) => {
                                    e.stopPropagation();
                                    toggleExpand(accountKey);
                                 }}
                                 aria-label="toggle"
                              />
                           </Flex>
                        );
                     return (
                        <div
                           key={index}
                           style={{
                              ...tdBase,
                              display: 'table-cell',
                              width: colDef.flexPct,
                              textAlign: index === 0 ? 'left' : colDef.align,
                              fontWeight: 600,
                              fontSize: '14px',
                              color: isDark ? '#fff' : '#000',
                              backgroundColor: isDark ? '#17234dff' : '#F6F0F0',
                           }}>
                           {cellValue}
                        </div>
                     );
                  })}
               </div>,
            );
         }

         return null;
      },
      [flatRowsRef, visibleColDefs, renderDataRows, formatNumberWithSmallDecimalZero, toggleExpand],
   );

   const handleDeleteFormat = async (id) => {
      try {
         await dispatch(deleteReportFormat(id));
         if (editData?.id === id) {
            setIsEditShowHide(false);
            setEditData({});
         }
         dispatch(getReportFormat());
      } catch (error) {
         console.error('Delete error:', error);
      }
   };

   const formatOptionLabel = ({ label, isDynamic, id }, { context }) => (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
         <span>{label}</span>
         {isDynamic && context === 'menu' && (
            <button
               onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteFormat(id);
               }}
               style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ff4d4f', padding: '0 5px' }}
               title="Delete this format">
               <MdDelete />
            </button>
         )}
      </div>
   );

   const handleReportTypeChange = (selectedOption) => {
      setReportType(selectedOption.value);
      setExpandedItems({});
      dispatch(getReportFormat());
   };

   useEffect(() => {
      dispatch(getReportFormat());
   }, [dispatch]);

   const handleShowHideFormOpen = async () => {
      setIsShowHideColumn(true);
      const formatData = reportformat.find((f) => f.title === reportType);
      if (formatData) {
         setIsEditShowHide(true);
         setEditData(formatData);
      } else {
         setIsEditShowHide(false);
         setEditData({});
      }
   };

   const startEditing = async (id, rowData) => {
      await dispatch(
         getDaybookForPayments({
            type: isBankPageTrue ? 14 : 13,
            companyId: user?.loginhistory?.companyId,
            ...(shouldSendIdInDaybook && { companyIds: user?.loginhistory?.companyId }),
         }),
      );
      await dispatch(
         getAccount({
            compId: user?.loginhistory?.companyId,
            status: true,
            ...(shouldSendIdInAccount && { companyIds: user?.loginhistory?.companyId }),
         }),
      );
      const selectAcc = accountData.filter((acc) => acc.id === rowData.accountId);
      setSelectedEditAccount(selectAcc[0]);
      setFormData((prev) => ({ ...prev, id, ...rowData }));
      setIsOutstandingModalOpen(true);
      setUpdateFormLoading(true);
   };

   const handleClearData = () => {
      setPendingVoucher([]);
      setFormData({
         companyId: parseInt(localStorage.getItem('companyId')),
         txnDate: new Date().toISOString().split('T')[0],
         daybookId: daybookTypeData?.length === 1 ? daybookTypeData[0].id : '',
         docNumber: 0,
         txnType: `${transactionType === 'payment' ? 1 : 0}`,
         accountId: null,
         amount: receivedAmount,
         brokerId: null,
         supplierId: 0,
         chequeNo: 0,
         transactionNo: 0,
         bankId: 0,
         bankBranchId: 0,
         particulars: '',
         depositeDate: '',
         clearingDate: '',
         tdsApplicable: false,
         tdsAccountId: 0,
         tdsLimit: 0,
         tdsRate: 0,
         tdsCess: 0,
         tdsSurcharge: 0,
         tdsAmount: 0,
         tdsCessAmount: 0,
         tdsSurchargeAmount: 0,
         tdsHCessAmount: 0,
         tdsInterestAmount: 0,
         tdsPenaltyAmount: 0,
         tdsOthersAmount: 0,
         notes1: '',
         notes2: '',
         notes3: '',
         notes4: '',
         notes5: '',
         userNote: '',
         taxableValue: '',
         GSTAmount: 0,
         stateOfSupply: 0,
         isRCM: false,
         GSTSubTxnType: 0,
         HSNSACId: 0,
         typeofSupply: 0,
         partyBillNo: 0,
         GSTTxnType: 0,
         outAdjustments: [],
      });
      setReceivedAmount(0);
      setTotalPendingAccount(0);
   };

   const ColGroup = () => (
      <colgroup>
         {visibleColDefs.map((col) => (
            <col key={col.id} style={{ width: col.flexPct }} />
         ))}
      </colgroup>
   );

   const tableBodyHeight = 'calc(100vh - 320px)';

   return (
      <>
         <Flex pr="25px" mb="5px" justifyContent="space-between" align="center" mt="50px" overflow={'hidden'}>
            <Flex>
               <img
                  src={back}
                  alt="Go Back"
                  width="15px"
                  onClick={() => window.history.back()}
                  style={{ cursor: 'pointer' }}
               />
               <Text color={textColor} fontSize="15px" fontWeight="700" lineHeight="100%" ml={5}>
                  Outstanding
               </Text>
            </Flex>
            <Flex gap={2}>
               <Box cursor={'pointer'} onClick={() => handleShowHideFormOpen()} mr={2}>
                  {isStaticReportType ? <FiPlusCircle size={22} /> : <LucideEdit size={22} />}
               </Box>
               <Button size="sm" variant="outline" onClick={expandAll} leftIcon={<MdExpand />}>
                  Expand All
               </Button>
               <Button size="sm" variant="outline" onClick={collapseAll} leftIcon={<MdCompress />}>
                  Collapse All
               </Button>
            </Flex>
         </Flex>

         <Box mt="15px" bg={backgroundColor} px={4} py={0} borderRadius="7px">
            <Flex alignItems="center" gap={3} justifyContent={'end'}>
               <div flex="1" mr={''} justifyContent="center">
                  <Box my={2} width="300px" fontSize={'13px'} fontWeight={500} display={{ base: 'none', xl: 'block' }}>
                     <GridItem className="seperator-width" mt={5}>
                        {renderDynamicDropdown(
                           'company',
                           'Company',
                           lastcompanyOptions,
                           {
                              value: companyFilter,
                              onChange: (selectedOptions) => setCompanyFilter(selectedOptions ? selectedOptions : []),
                           },
                           {},
                           textColor,
                           false,
                           'Select company',
                           true,
                           null,
                           true,
                        )}
                     </GridItem>
                  </Box>
               </div>
               <Box flex="1" display={{ base: 'none', xl: 'flex' }}>
                  <Flex alignItems={'center'} mt={3}>
                     <PeriodDatePicker
                        value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                        onChange={handleDateRangeChange}
                        defaultPeriod="last7Days"
                        style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                     />
                  </Flex>
                  <Box my={2} zIndex={3} width={'150px'} fontSize={'13px'} fontWeight={500} mr={2}>
                     <label>Report Type</label>
                     <Select
                        options={reportTypeOptions}
                        formatOptionLabel={formatOptionLabel}
                        value={reportTypeOptions.find((option) => option.value === reportType)}
                        onChange={handleReportTypeChange}
                        placeholder="Select Report Type"
                        styles={{
                           control: (b, s) => ({
                              ...b,
                              minHeight: '30px',
                              height: '30px',
                              backgroundColor: controlBg,
                              borderColor: controlBorder,
                              boxShadow: s.isFocused ? focusBoxShadow : b.boxShadow,
                              '&:hover': { borderColor: controlBorderHover },
                           }),
                           valueContainer: (b) => ({ ...b, height: '30px', padding: '0 6px', color: textColor }),
                           indicatorsContainer: (b) => ({ ...b, height: '30px' }),
                           singleValue: (b) => ({ ...b, color: textColor }),
                           placeholder: (b) => ({ ...b, color: placeholderColor }),
                           option: (b, s) => ({
                              ...b,
                              backgroundColor: s.isFocused ? optionHoverBg : optionBg,
                              color: textColor,
                              fontWeight: s.data?.isDynamic ? 'bold' : 'normal',
                              '&:hover': { backgroundColor: optionHoverBg },
                           }),
                           groupHeading: (b) => ({ ...b, backgroundColor: menuBg, border: `1px solid ${menuBorder}` }),
                           dropdownIndicator: (b) => ({
                              ...b,
                              color: indicatorColor,
                              '&:hover': { color: indicatorHoverColor },
                           }),
                           clearIndicator: (b) => ({
                              ...b,
                              color: indicatorColor,
                              '&:hover': { color: indicatorHoverColor },
                           }),
                        }}
                     />
                  </Box>
                  <Box my={2} fontSize={'13px'} zIndex={3} fontWeight={500} display={{ base: 'none', lg: 'block' }}>
                     <label>Outstanding Type</label>
                     <Select
                        options={osTypeOptions}
                        value={osTypeOptions.find((option) => option.value === osType)}
                        onChange={(selectedOption) => setOsType(selectedOption.value)}
                        placeholder="Select Outstanding Type"
                        styles={{
                           control: (b, s) => ({
                              ...b,
                              minHeight: '30px',
                              height: '30px',
                              backgroundColor: controlBg,
                              borderColor: controlBorder,
                              boxShadow: s.isFocused ? focusBoxShadow : b.boxShadow,
                              '&:hover': { borderColor: controlBorderHover },
                           }),
                           valueContainer: (b) => ({ ...b, height: '30px', padding: '0 6px', color: textColor }),
                           indicatorsContainer: (b) => ({ ...b, height: '30px' }),
                           singleValue: (b) => ({ ...b, color: textColor }),
                           placeholder: (b) => ({ ...b, color: placeholderColor }),
                           option: (b, s) => ({
                              ...b,
                              backgroundColor: s.isFocused ? optionHoverBg : optionBg,
                              color: textColor,
                              '&:hover': { backgroundColor: optionHoverBg },
                           }),
                           menu: (b) => ({ ...b, backgroundColor: menuBg, border: `1px solid ${menuBorder}` }),
                           dropdownIndicator: (b) => ({
                              ...b,
                              color: indicatorColor,
                              '&:hover': { color: indicatorHoverColor },
                           }),
                           clearIndicator: (b) => ({
                              ...b,
                              color: indicatorColor,
                              '&:hover': { color: indicatorHoverColor },
                           }),
                        }}
                     />
                  </Box>
               </Box>
               <Flex>
                  <Flex alignItems="center">
                     <Box flex="1" mr={3}>
                        <MotionFlex
                           ref={wrapperRef}
                           align="center"
                           bg={bg}
                           borderRadius="full"
                           cursor="pointer"
                           px={expanded ? 3 : 0}
                           w={expanded ? '250px' : '40px'}
                           h="40px"
                           transition="all 0.3s ease"
                           onClick={() => setExpanded(true)}>
                           <MotionSearchIcon
                              color={icon}
                              animate={{ rotate: expanded ? 0 : 90 }}
                              transition={{ duration: 0.3 }}
                              style={{ marginRight: expanded ? '8px' : '10px', marginLeft: expanded ? '0' : '10px' }}
                           />
                           {expanded && (
                              <Input
                                 variant="unstyled"
                                 placeholder="Search ..."
                                 value={searchQuery}
                                 onChange={handleSearchChange}
                                 onKeyPress={(e) => {
                                    if (e.key === 'Enter') handleRefresh();
                                 }}
                                 autoFocus
                                 color={icon}
                                 flex="1"
                              />
                           )}
                        </MotionFlex>
                     </Box>
                     <Button onClick={() => fetchData()} _hover={{ bg: 'blue.50' }} mr={2}>
                        <MdOutlineRefresh size={20} mr={2} />
                     </Button>
                     <Button cursor={'pointer'} onClick={onFilterOpen} mr={2}>
                        <IoFilterOutline size={22} />
                     </Button>
                     <Flex mr={2}>
                        <Popover>
                           <PopoverTrigger>
                              <IconButton
                                 icon={<Image src={Download} boxSize="24px" />}
                                 aria-label="Download Options"
                              />
                           </PopoverTrigger>
                           <PopoverContent width="220px" zIndex="10" bg={backgroundColor} mr={8}>
                              <PopoverBody p="3">
                                 <Button
                                    width="100%"
                                    variant="ghost"
                                    _hover={{ bg: 'blue.100' }}
                                    onClick={downloadAsExcel}
                                    justifyContent="space-between"
                                    mb={3}>
                                    <img src={xls} alt="Download XLS" width="30px" />
                                    Download Excel
                                 </Button>
                                 <Button
                                    width="100%"
                                    variant="ghost"
                                    _hover={{ bg: 'blue.100' }}
                                    onClick={handleDownloadPDF}
                                    justifyContent="space-between">
                                    <img src={xls} alt="Download PDF" width="30px" />
                                    Download PDF
                                 </Button>
                              </PopoverBody>
                           </PopoverContent>
                        </Popover>
                     </Flex>
                  </Flex>
               </Flex>
               <Box ml={1}>
                  <Flex display={{ base: 'block', xl: 'none' }}>
                     <Button variant="unstyled" onClick={onOpen}>
                        <Image src={DotIcon} alt="Menu" width="25px" />
                     </Button>
                  </Flex>
               </Box>

               <Drawer isOpen={isOpen} placement="bottom" onClose={onClose} finalFocusRef={fromDateInputRef}>
                  <DrawerOverlay />
                  <DrawerContent borderTopRadius="20px">
                     <DrawerCloseButton />
                     <DrawerHeader borderBottomWidth="1px">Filters</DrawerHeader>
                     <DrawerBody>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'company',
                              'Company',
                              lastcompanyOptions,
                              {
                                 value: companyFilter,
                                 onChange: (selectedOptions) =>
                                    setCompanyFilter(selectedOptions ? selectedOptions : []),
                              },
                              {},
                              textColor,
                              false,
                              'Select company',
                              true,
                              undefined,
                              true,
                           )}
                        </GridItem>
                        <Box my={4} width="100%" fontSize="13px" fontWeight={500}>
                           <label>Report Type</label>
                           <Select
                              options={reportTypeOptions}
                              value={reportTypeOptions.find((option) => option.value === reportType)}
                              onChange={(selectedOption) => setReportType(selectedOption.value)}
                              placeholder="Select Report Type"
                              styles={{
                                 control: (b) => ({ ...b, minHeight: '30px', height: '30px' }),
                                 valueContainer: (b) => ({ ...b, height: '30px', padding: '0 6px' }),
                                 indicatorsContainer: (b) => ({ ...b, height: '30px' }),
                              }}
                           />
                        </Box>
                        <Box my={4} width="100%" fontSize="13px" fontWeight={500}>
                           <label>Outstanding Type</label>
                           <Select
                              options={osTypeOptions}
                              value={osTypeOptions.find((option) => option.value === osType)}
                              onChange={(selectedOption) => setOsType(selectedOption.value)}
                              placeholder="Select Outstanding Type"
                              styles={{
                                 control: (b) => ({ ...b, minHeight: '30px', height: '30px' }),
                                 valueContainer: (b) => ({ ...b, height: '30px', padding: '0 6px' }),
                                 indicatorsContainer: (b) => ({ ...b, height: '30px' }),
                              }}
                           />
                        </Box>
                        <Box alignItems={'center'} mt={3}>
                           <PeriodDatePicker
                              value={
                                 datePartyWiseSalesRange?.fromDate && datePartyWiseSalesRange?.toDate
                                    ? [
                                       new Date(datePartyWiseSalesRange.fromDate),
                                       new Date(datePartyWiseSalesRange.toDate),
                                    ]
                                    : null
                              }
                              onChange={handleDateRangeChange}
                              style={{ width: '100%', marginRight: 20, borderRadius: 5, height: 35 }}
                           />
                        </Box>
                        <Button colorScheme="green" width="100%" onClick={onClose} mt={4}>
                           Apply Filters
                        </Button>
                     </DrawerBody>
                  </DrawerContent>
               </Drawer>
            </Flex>
         </Box>
         <Grid overflow="hidden">
            <Card mt="15px" borderRadius="7px" overflow="hidden">
               <Box position="relative" width="100%">
                  {isFilterLoading && (
                     <Box
                        position="fixed"
                        top={0} left={0} right={0} bottom={0}
                        zIndex={9999}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        bg={isDark ? 'rgba(10,20,50,0.60)' : 'rgba(255,255,255,0.60)'}
                        backdropFilter="blur(3px)"
                     >
                        <Flex direction="column" align="center" gap={3}>
                           <Loader />
                        </Flex>
                     </Box>
                  )}
                  {/* ── STICKY HEADER ── */}
                  <Box overflowX="auto" className="custom-scrollbar">
                     <table
                        style={{
                           width: '100%',
                           tableLayout: 'fixed',
                           borderCollapse: 'collapse',
                        }}>
                        <ColGroup />
                        <thead>
                           {dynamicOptionValues?.formatData?.viewJson ? (
                              <tr>
                                 {visibleColDefs.map((colDef, index) => (
                                    <th
                                       key={index}
                                       style={{
                                          width: colDef.flexPct,
                                          padding: '8px 8px',
                                          fontSize: '12px',
                                          background: isDark ? '#101F4A' : '#F5F5F5',
                                          position: 'sticky',
                                          top: 0,
                                          zIndex: 1,
                                          whiteSpace: 'nowrap',
                                          borderTop: '1px solid #e2e8f0',
                                          borderBottom: '1px solid #e2e8f0',
                                          textAlign: colDef.align,
                                          fontWeight: 600,
                                          textTransform: 'uppercase',
                                          letterSpacing: '0.05em',
                                       }}>
                                       {colDef.header}
                                    </th>
                                 ))}
                              </tr>
                           ) : (
                              table.getHeaderGroups().map((headerGroup) => (
                                 <tr key={headerGroup.id}>
                                    {visibleColDefs.map((colDef, index) => {
                                       const header = headerGroup.headers.find((h) => h.column.id === colDef.id);
                                       return (
                                          <th
                                             key={colDef.id}
                                             style={{
                                                width: colDef.flexPct,
                                                padding: '8px 8px',
                                                fontSize: '12px',
                                                background: isDark ? '#101F4A' : '#F5F5F5',
                                                position: 'sticky',
                                                top: 0,
                                                zIndex: 1,
                                                whiteSpace: 'nowrap',
                                                cursor: 'pointer',
                                                borderTop: '1px solid #e2e8f0',
                                                borderBottom: '1px solid #e2e8f0',
                                                textAlign: colDef.align,
                                                fontWeight: 600,
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.05em',
                                             }}
                                             onClick={header?.column.getToggleSortingHandler()}>
                                             <div
                                                style={{
                                                   display: 'flex',
                                                   justifyContent:
                                                      colDef.align === 'right' ? 'flex-end' : 'space-between',
                                                   alignItems: 'center',
                                                   gap: '4px',
                                                }}>
                                                {colDef.header}
                                                {header && { asc: '↑', desc: '↓' }[header.column.getIsSorted()]}
                                             </div>
                                          </th>
                                       );
                                    })}
                                 </tr>
                              ))
                           )}
                        </thead>
                     </table>
                  </Box>

                  {/* ── VIRTUALIZED BODY — rendered as divs OUTSIDE <table> ── */}
                  <Box
                     overflowX="auto"
                     className="custom-scrollbar"
                     height={tableBodyHeight}
                     style={{ minHeight: '300px' }}>
                     <Box style={{ minWidth: '100%' }}>
                        <VariableSizeList
                           ref={listRef}
                           height={window.innerHeight * 0.62}
                           itemCount={flatRows.length}
                           itemSize={getItemSize}
                           width="100%"
                           overscanCount={15}
                           style={{ overflowX: 'hidden' }}>
                           {VirtualRow}
                        </VariableSizeList>
                     </Box>
                  </Box>
               </Box>
            </Card>
         </Grid>

         {/* ── Modals unchanged ── */}
         {isOpenPurchaseReturnSingleView && (
            <div className="fixed inset-0 z-[999]">
               {isModalLoading ? (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
                     <Loader />
                  </div>
               ) : viewDetail ? (
                  <SalesDetails
                     isOpen={isOpenPurchaseReturnSingleView}
                     onClose={handleSalesDetailsClose}
                     singleEntityRights={
                        saleInvoiceRight || saleReturnRight || purchaseInvoiceRight || purchaseReturnRight
                     }
                     title={
                        entityType === 'saleinvoice'
                           ? 'Sales Invoice'
                           : entityType === 'salereturn'
                              ? 'Sales Return'
                              : entityType === 'purchaseinvoice'
                                 ? 'Purchase Invoice'
                                 : 'Purchase Return'
                     }
                     entityType={entityType}
                     singleEntity={viewDetail}
                     handlePrevPage={handlePrevPage}
                     handleNextPage={handleNextPage}
                     setIsEditFormOpen={setIsEditFormOpen}
                     setIsOpenSingleView={setIsOpenPurchaseReturnSingleView}
                     isEditFormOpen={isEditFormOpen}
                     viewDetail={viewDetail}
                     lineItems={viewDetail?.lineitems}
                     billTerms={viewDetail?.purchasereturnbillteams}
                     onDelete={deletePurchaseReturn}
                     handleSerchClose={() => { }}
                  />
               ) : (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
                     <Loader />
                  </div>
               )}
            </div>
         )}

         <ColumnShowHide
            isOpen={isShowHideColumn}
            onClose={() => setIsShowHideColumn(false)}
            data={columnsData}
            setShowHideData={setShowHideData}
            isedit={isEditShowHide}
            editData={editData}
            selectedFormat={reportTypeOptions.dynamicOptions}
            FixdefName1={'OutstandingDate'}
            FixdefName2={'OutstandingParty'}
            FixdefName3={'OutstandingBroker'}
            staticOption={staticOption}
            dynamicEditOption={dynamicEditOption}
         />

         <SalesSingleDataView
            isOpenSingleView={isOpenSingleViewinr}
            onClose={handleSalesSingleDataViewClose}
            entityType={entityType}
            singleEntity={singleEntity}
            dynamicUserDetails={dynamicUserDetails}
            onEditFormClose={() => setIsOpenSingleViewinr(true)}
            setIsOpenSingleView={setIsOpenSingleViewinr}
            isEditFormOpen={isEditFormOpen}
            setIsEditFormOpen={setIsEditFormOpen}
            title={entityType === 'issuemaster' ? 'Issue' : 'Receive'}
            handleViewSingleData={handleViewSingleData}
         />

         <AccountingReportsFilter
            type={reportType}
            osType={osType}
            isOpen={isFilterOpen}
            onClose={onFilterClose}
            companyIds={companyIds}
            fromDate={datePartyWiseSalesRange.fromDate}
            toDate={datePartyWiseSalesRange.toDate}
            entityType="outstanding"
            onApply={() => setIsFilterLoading(true)}
         />

         {updateFormLoading && formData.id && (
            <PaymentcaseFormEdit
               isOutstandingModalOpen={isOutstandingModalOpen}
               setIsOutstandingModalOpen={setIsOutstandingModalOpen}
               daybookTypeData={daybookTypeData}
               validationSchema={validationSchema}
               errors={errors}
               setErrors={setErrors}
               selectedAccount={selectedEditAccount}
               setSelectedAccount={setSelectedEditAccount}
               userData={accountData}
               type={13}
               isEditMode={true}
               receivedAmount={receivedAmount}
               setReceivedAmount={setReceivedAmount}
               totalPendingAccount={totalPendingAccount}
               setTotalPendingAccount={setTotalPendingAccount}
               formData={formData}
               setFormData={setFormData}
               transactionType={transactionType}
               handleClearData={handleClearData}
               pendingVoucher={pendingVoucher}
               setPendingVoucher={setPendingVoucher}
               currentPage={1}
               limit={10}
               companyId={companyId}
               sorting={sorting}
               pagination={10}
            />
         )}

         {isOpenSingleViewcnb && (
            <div className="fixed inset-0 z-[999]">
               {isModalLoading ? (
                  <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[9999]">
                     <Loader />
                  </div>
               ) : singleEntity ? (
                  <ViewSingleCashBankData
                     isOpenSingleView={isOpenSingleViewcnb}
                     onClose={() => setIsOpenSingleViewcnb(false)}
                     singleEntity={singleEntity}
                     formType="voucher"
                     isBankPageTrue={isBankPageTrue}
                     UserRights={(cashPaymentRight && cashReceiveRight) || (bankPaymentRight && bankReceiveRight)}
                     paymentRight={cashPaymentRight || bankPaymentRight}
                     receiveRight={cashReceiveRight || bankReceiveRight}
                     startEditing={(data) => startEditing(data.id, data)}
                  />
               ) : (
                  <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[9999]">
                     <Loader />
                  </div>
               )}
            </div>
         )}

         <DeletePasswordModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onConfirm={
               entityType === 'saleinvoice' || entityType === 'purchaseinvoice' ? deleteRecordForSales : deleteRecord
            }
            id={dataId}
            deleteApi={
               entityType === 'saleinvoice'
                  ? deleteSaleInvoice
                  : entityType === 'purchaseinvoice'
                     ? deletePurchaseInvoice
                     : entityType === 'salereturn'
                        ? deleteSaleReturnInvoice
                        : deletePurchaseReturnInvoice
            }
            dispatch={dispatch}
            type={entityType === 'saleinvoice' || entityType === 'purchaseinvoice' ? 'purchase' : 'receive'}
            userGlobalSettingsData={userGlobalSettingsData}
         />
      </>
   );
};

export default Outstanding;
